<template>

  <div class="judging-program-view" ref="programContainer">
    <div class="card box_component">
      <div class="card-header d-flex flex-wrap justify-content-between align-items-center">
        <h5 class="w-100 w-md-auto d-flex flex-column flex-md-row align-items-center">
          <span v-if="isCompetition">
            {{ competitionName }}
          </span>

          <span v-if="isTraining && isJudgeTrainingContext">
            Zona de entrenamiento de juez
            <span v-if="headerAthleteName"> - {{ headerAthleteName }}</span>
           </span>

          <span v-else-if="isTraining">
            {{ $t('judging_program.round_data.training_title') }}
           </span>

          <span v-if="showTrainingHeaderDetails" class="d-none d-md-inline mx-2">|</span>

          <span v-if="showTrainingHeaderDetails && headerAthleteName">
            {{ headerAthleteName }}
          </span>

          <span v-if="showTrainingHeaderDetails" class="d-none d-md-inline mx-2">|</span>

          <span v-if="isCompetition">
            {{ findRoundByCompetition }}
          </span>

          <span v-if="isTraining && showTrainingHeaderDetails">
            {{ findRoundByTraining }}
            <span v-if="this.trainingRoundsIdToEdit" class="link-plain" @click.prevent="editInfoRound">
              <i class="fas fa-pen"></i>
            </span>
          </span>
        </h5>
      </div>

    </div>
    <div class="program-layout" :class="{ 'program-layout--split': isVideoSplitDesktop }">
    <!-- VideoBox -->
    <Teleport to="body" :disabled="!isVideoFloating || isVideoSplitDesktop">
      <div class="fixed-video-box" ref="fixedVideoBox" :class="{ 'fixed-video-box--floating': isVideoFloating, 'fixed-video-box--split': isVideoSplitDesktop }" :style="floatingVideoStyle">
        <div class="card box_component" id="cardVideoTutorial" ref="videoCard" :class="{ 'video-card--floating': isVideoFloating }">
          <div
            class="card-header d-flex justify-content-between align-items-center"
            :class="{ 'video-card-header--draggable': isVideoFloating }"
            @mousedown="startVideoDrag"
          >
            <h5>
              {{ $t('judging_program.round_video_box.card_header') }}
            </h5>
            <div class="d-flex align-items-center gap-1">
              <button
                v-if="isDesktopViewport"
                class="btn btn-link"
                type="button"
                :title="isVideoFloating ? 'Fijar video' : 'Activar ventana flotante'"
                :aria-label="isVideoFloating ? 'Fijar video' : 'Activar ventana flotante'"
                @mousedown.stop
                @click="toggleVideoFloating"
              >
                <i :class="isVideoFloating ? 'fas fa-down-left-and-up-right-to-center fa-lg text-primary' : 'fas fa-up-right-and-down-left-from-center fa-lg text-secondary'"></i>
              </button>
              <button
                class="btn btn-link video-split-toggle"
                type="button"
                :title="isVideoSplitDesktop ? 'Salir de vista dividida' : 'Activar vista dividida'"
                :aria-label="isVideoSplitDesktop ? 'Salir de vista dividida' : 'Activar vista dividida'"
                :disabled="!isDesktopViewport"
                @mousedown.stop
                @click="toggleVideoSplit"
              >
                <i :class="isVideoSplitDesktop ? 'fas fa-table-columns fa-lg text-primary' : 'fas fa-table-columns fa-lg text-secondary'"></i>
              </button>
              <button
                  class="btn btn-link"
                  type="button"
                  @mousedown.stop
                  @click="toggleCollapse();"
                  :aria-expanded="isExpanded ? 'true' : 'false'"
              >
                <i v-if="isExpanded" class="fas fa-minus-circle fa-lg text-secondary"></i>
                <i v-else class="fas fa-plus-circle fa-lg text-secondary"></i>
              </button>
            </div>
          </div>
          <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div v-if="isExpanded" key="content" class="box">
              <div class="card-body p-1" >
                <div class="container text-center">
                  <div class="row">
                    <div class="col-12 p-0">
                      <div v-if="!videoUrl">
                        <div v-if="!videoUrl && !isView" class="mb-3">
                          <label for="videoInput" class="form-label">{{ $t('judging_program.round_video_box.input_label') }}</label>
                          <div class="input-group">
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('judging_program.round_video_box.placeholder')"
                                id="videoInput"
                                v-model="videoLink"
                                :disabled="videoUrl !== null"
                            />
                            <button
                                class="btn btn-warning"
                                @click="saveVideoLink"
                                :disabled="videoUrl !== null"
                            >
                              <i class="fa-solid fa-cloud-arrow-up"></i>
                              {{ $t('judging_program.round_video_box.button_save') }}
                            </button>
                          </div>
                        </div>
                        <div v-if="isView" class="mb-3">
                          <p>{{ $t('judging_program.round_video_box.not_video') }}</p>
                        </div>
                      </div>
                      <div v-else>
                        <YoutubePlayer :video-url="videoUrl" :can-delete="canDeleteCurrentVideo" :is-judge-training-round="isJudgeTrainingContext" @delete-video-url="deleteVideoUrlComponent()" @refresh-box-size="adjustContentHeight()" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <button
            v-if="isVideoFloating && isExpanded"
            class="video-resize-handle"
            type="button"
            title="Cambiar tamano"
            aria-label="Cambiar tamano"
            @mousedown.stop.prevent="startVideoResize"
          >
            <i class="fas fa-up-right-and-down-left-from-center"></i>
          </button>
        </div>
      </div>
    </Teleport>
    <div class="scrollable-content" ref="scrollableContent">
      <div
          v-if="requiresRoundCode"
          class="card box_component mb-3"
          id="cardCodeValidator"
      >
        <h5 class="card-header d-flex align-items-center gap-2">
          <i class="fa-solid fa-shield-halved text-primary"></i>
          <span>{{ $t('judging_program.round_video_box.code_validator_title') || 'Validar código del video' }}</span>
        </h5>
        <div class="card-body">
          <p class="text-muted small mb-3">
            {{ $t('judging_program.round_video_box.code_validator_help') || 'Ingresa el código de 3 caracteres que ves en el video para desbloquear las herramientas de juzgar.' }}
          </p>
          <div class="input-group mb-2 code-input-group">
            <input
                type="text"
              class="form-control code-input"
              v-model="codeInput"
              maxlength="3"
                :disabled="codeStatus === 'valid' || codeBusy"
              @input="handleCodeInput"
                @keyup.enter="validateVerificationCode"
              placeholder="ABC"
            />
            <button
                class="btn btn-primary"
                :disabled="codeBusy || !codeInputTrimmed || codeStatus === 'valid'"
                @click="validateVerificationCode"
            >
              <span v-if="codeBusy" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>{{ $t('judging_program.round_video_box.code_validator_button') || 'Validar código' }}</span>
            </button>
          </div>
          <p v-if="codeStatus === 'valid'" class="text-success small mb-0">
            <i class="fa-solid fa-check-circle me-1"></i>
            {{ $t('judging_program.round_video_box.code_validator_success') || 'Código válido. Herramientas desbloqueadas.' }}
          </p>
          <p v-else-if="codeStatus === 'invalid'" class="text-danger small mb-0">
            <i class="fa-solid fa-triangle-exclamation me-1"></i>
            {{ codeError || ($t('judging_program.round_video_box.code_validator_error') || 'Código incorrecto. Intenta nuevamente.') }}
          </p>
          <p v-else class="text-muted small mb-0">
            {{ $t('judging_program.round_video_box.code_validator_hint') || 'Las herramientas estarán bloqueadas hasta validar el código.' }}
          </p>
        </div>
      </div>

      <div class="locked-wrapper" :class="{ locked: isCodeLocked }">
        <div v-if="isCodeLocked" class="locked-overlay">
          <div class="locked-overlay__content">
            <i class="fa-solid fa-lock me-2"></i>
            <span>{{ $t('judging_program.round_video_box.code_locked') || 'Ingresa el código para desbloquear las herramientas.' }}</span>
          </div>
        </div>

        <div class="locked-body">
      <!-- SearchBox -->
      <div v-if="!isView" class="card box_component" id="cardSearchTutorial">
        <h5 class="card-header">
          {{ $t('judging_program.trick_selector_box.card_header') }}
          <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                 {{ this.modeProgram === 1 ? $t('judging_program.trick_selector_box.title_opcion_1') :
              this.modeProgram === 2 ? $t('judging_program.trick_selector_box.title_opcion_2') :
                  this.modeProgram === 3 ? $t('judging_program.trick_selector_box.title_opcion_3') :
                      this.modeProgram === 4 ? $t('judging_program.trick_selector_box.title_opcion_4') :
                          'ERROR RULES' }}
            </span>
        </h5>
        <div class="card-body p-1" >
          <div class="container text-center">
            <div class="row">
              <div class="col-12 py-2 px-0">
                <SearchBox
                    ref="searchFocus"
                    :tricks="tricks"
                  :athlete-id="activeAthleteId"
                  :token="token"
                    :selectedListTricks="selectedListTricks"
                    :validatedTricks="validatedTricks"
                    :trickEdit="trickEdit"
                    :trickEditIndex="trickEditIndex"
                    :trickValidatedEdit="trickValidatedEdit"
                    :trickValidatedEditIndex="trickValidatedEditIndex"
                    :trickValidatedEditSubIndex="trickValidatedEditSubIndex"
                    @update-selected-tricks="handleUpdateSelectedTricks"
                    @update-validated-tricks="handleUpdateValidatedTricks"
                    @cancel-trick-edit="handleCancelTrickEdit"

                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- SelectedBox -->
      <div v-if="!isView" class="card box_component" :style="trickEdit || trickValidatedEdit ? { opacity: '0.3' } : {}" id="cardSelectedTutorial">
        <h5 class="card-header position-relative">
          {{ $t('judging_program.selected_tricks_box.card_header') }}
          <button
            v-if="comboValidatedEditIndex !== null && comboValidatedEditIndex !== undefined && comboValidatedEditIndex >= 0"
            type="button"
            class="btn btn-sm btn-outline-secondary ms-2"
            :class="{ active: selectedReorderMode }"
            @click.stop="$refs.selectedBox && $refs.selectedBox.toggleReorderModeFromParent && $refs.selectedBox.toggleReorderModeFromParent()"
            title="Reordenar"
          >
            <i class="fas fa-arrows-alt"></i>
          </button>
          <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                {{ selectedListTricks.length || 0 }}
            </span>
        </h5>
        <div class="card-body px-0" >
          <div class="container text-center">
            <div class="row">
              <div class="col-12 py-2 px-0">
                <SelectedBox
                    ref="selectedBox"
                    :selectedListTricks="selectedListTricks"
                    :validatedTricks="validatedTricks"
                    :comboCount="comboCount"
                    :comboValidatedEditIndex="comboValidatedEditIndex"
                    @update-validated-tricks="handleUpdateValidatedTricks"
                    @clear-selected-tricks="clearSelectedTricks"
                    @update-tricks-selected="updateTrickSelected"
                    @delete-trick-selected="deleteTrickSelected"
                    @reorder-selected-tricks="handleReorderSelectedTricks"
                  @reorder-mode-changed="handleReorderModeChanged"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ValidatedBox -->
      <div class="card box_component" :style="trickEdit || trickValidatedEdit || comboValidatedEditIndex !== null ? { opacity: '0.3' } : {}" id="cardValidatedTutorial">
        <h5 class="card-header">
          <span>{{ $t('judging_program.validated_tricks_box.card_header') }}</span>
          <button
            v-if="!isView && validatedTricks.length"
            type="button"
            class="btn btn-sm btn-outline-secondary ms-2"
            :class="{ active: validatedReorderMode }"
            @click.stop="$refs.validatedBox && $refs.validatedBox.toggleReorderModeFromParent && $refs.validatedBox.toggleReorderModeFromParent()"
            title="Reordenar"
          >
            <i class="fas fa-arrows-alt"></i>
          </button>
          <span class="position-absolute top-0 end-0 translate-middle-y badge rounded-pill bg-secondary">
                {{ this.totalTricks || 0 }}
             </span>
        </h5>
        <div class="card-body px-0">
          <div class="container text-center">
            <div class="row">
              <div class="col-12 p-0">
                <ValidationBox
                    ref="validatedBox"
                    :validatedTricks="validatedTricks"
                    :isValidated="isReviewOrView"
                  :isReadOnly="isView"
                  :diffs="validatedTricksDiffs"
                    @update-validated-tricks="handleUpdateValidatedTricks"
                    @update-trick-validated="updateTrickValidated"
                    @delete-trick-validated="deleteTrickValidated"
                    @update-all-validated-tricks="handleUpdateAllValidatedTricks"
                    @all-tricks-confirmed="handleAllTricksConfirmed"
                    @reorder-mode-changed="handleValidatedReorderModeChanged"
                    @open-editor-diff="handleOpenEditorDiff"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- TotalBox -->
      <div class="card box_component" id="cardTotalsTutorial">
        <h5 class="card-header">
          <span>{{ $t('judging_program.totals_tricks_box.card_header') }}</span>
        </h5>
        <div class="card-body px-0">
          <div class="container text-center">
            <div v-if="isHiddenScore" class="row">
              <!-- Scoring Box -->
              <div class="col-4">
                <div class="bar-item total-score-bar">
                  <div class="score-label">{{ $t('judging_program.totals_tricks_box.total_score') }}:</div>
                  <div class="score-value">{{ this.totalScore || 0 }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="bar-item total-variety-bar">
                  <div class="score-label">{{ $t('judging_program.totals_tricks_box.total_variety') }}:</div>
                  <div class="score-value">{{ this.countUniqueTrick.total || 0 }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="bar-item total-style-bar">
                  <div class="score-label">{{ $t('judging_program.totals_tricks_box.total_style') }}:</div>
                  <div class="score-value">{{ totalScorePrint.style}}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="total-bar">
                  <div class="score-label">{{ $t('judging_program.totals_tricks_box.total_scores') }}:</div>
                  <div class="score-value"><b>{{ formatScore(totalScorePrint.score) }}</b></div>
                </div>
              </div>
            </div>
            <!-- Si la ronda está publicada, muestra el textarea -->
            <div v-if="isPublishedRound">
              <div class="form-group mt-4">
                <label for="round-feedback">
                  {{$t('judging_program.totals_tricks_box.round_feedback_label')}}
                </label>
                <textarea
                    id="round-feedback"
                    v-model="roundFeedbackComment"
                    class="form-control"
                    rows="4"
                    :placeholder="$t('judging_program.totals_tricks_box.round_feedback_placeholder')"
                ></textarea>
              </div>
            </div>

            <!-- Si NO está publicada y hay contenido en el comentario, muestra una cajita -->
            <div
                v-if="feedBackInput && roundFeedbackComment && roundFeedbackComment.trim() !== ''"
                class="form-group mt-4"
            >
              <label>{{$t('judging_program.totals_tricks_box.round_feedback_label')}}</label>
              <div class="p-3 bg-light border rounded shadow-sm text-break">
                {{ roundFeedbackComment }}
              </div>
            </div>

            <JudgeInfo
              v-if="shouldShowJudgeInfo"
              :judge="judgeInfoData"
              :editors="editors"
              :scoring-duration="scoringDurationText"
              :diffs="validatedTricksDiffs"
              :external-open-event="editorDiffEvent"
              @view-profile="viewJudgeProfile"
            />

            <div  class="row mt-3">
              <div  v-if="isCompetitionCreate" class="col-6">
                <button @click.prevent="cancelCreateRound(this.roundCompetitionIdToCreate)" class="btn btn-danger">
                  <i class="fas fa-cancel"></i>
                  {{ $t('judging_program.totals_tricks_box.cancel')}}
                </button>
              </div>
              <div  v-if="isCompetitionCreate" class="col-6">
                <button @click="createScoreRound" class="btn btn-warning" :disabled="validatedReorderMode">
                  <i class="fas fa-save"></i>
                  {{ $t('judging_program.totals_tricks_box.score_btn') }}
                </button>
              </div>
              <div  v-if="isRoundCreate" class="col-6">
                <button @click.prevent="cancelViewRound()" class="btn btn-danger">
                  <i class="fas fa-cancel"></i>
                  {{ $t('judging_program.totals_tricks_box.cancel')}}
                </button>
              </div>
              <div  v-if="isRoundCreate" class="col-6">
                <button @click="storageScoreList" :disabled="!this.validatedTricks.length || validatedReorderMode" class="btn btn-warning">
                  <i class="fas fa-save"></i>
                  {{ $t('judging_program.totals_tricks_box.save') }}
                </button>
              </div>
              <div  v-if="isCompetitionEdit" class="col-6">
                <button @click.prevent="cancelEditRound(this.roundCompetitionIdToEdit)" class="btn btn-danger">
                  <i class="fas fa-cancel"></i>
                  {{ $t('judging_program.totals_tricks_box.cancel')}}
                </button>
              </div>
              <div  v-if="isCompetitionEdit" class="col-6">
                <button @click="editScoreRound" class="btn btn-warning" :disabled="validatedReorderMode">
                  <i class="fas fa-save"></i>
                  {{ $t('judging_program.totals_tricks_box.edit_btn') }}
                </button>
              </div>
              <div  v-if="isRoundEdit" class="col-6">
                <button @click.prevent="cancelViewRound()" class="btn btn-danger">
                  <i class="fas fa-cancel"></i>
                  {{ $t('judging_program.totals_tricks_box.cancel')}}
                </button>
              </div>
              <div  v-if="isRoundEdit" class="col-6">
                <button @click="updateScoreRound" class="btn btn-warning" :disabled="validatedReorderMode">
                  <i class="fas fa-save"></i>
                  {{ isJudgeTrainingFirstSaveMode ? $t('judging_program.totals_tricks_box.save') : $t('judging_program.totals_tricks_box.edit_btn') }}
                </button>
              </div>
              <div  v-if="isCompetitionView && !isReviewOrView" class="col-6">
                <button @click.prevent="cancelViewRound()" class="btn btn-secondary">
                  <i class="fas fa-cancel"></i>
                  {{ $t('judging_program.totals_tricks_box.close') }}
                </button>
              </div>
              <div v-if="canOpenRoundStatistics" class="col-6">
                <button @click.prevent="openRoundStatistics()" class="btn btn-info text-white">
                  <i class="fas fa-chart-column"></i>
                  {{ $t('menu.statistics') }}
                </button>
              </div>
              <div  v-if="isCompetitionView && isReviewOrView" class="col-6">
                <button @click.prevent="reviewRound()" :disabled="!isReviewReady" class="btn btn-warning">
                  <i class="fas fa-pen-to-square"></i>
                  {{ $t('judging_program.totals_tricks_box.review') }}
                </button>
              </div>
              <div  v-if="isCompetitionView && isReviewOrView" class="col-6">
                <button
                    @click.prevent="confirmAllFeedbacksFromParent()"
                    class="btn btn-success"
                    :disabled="!validatedTricks.length"
                >
                  <i class="fas fa-thumbs-up me-1"></i>
                  Confirm All
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
    </div>
  </div>
  <ConfirmationModal
      ref="confirmationModal"
      :message="modalMessage"
      :showCancel="showCancel"
      :showRuleSelector="modalShowRuleSelector"
      :ruleOptions="ruleOptions"
      :showNameInput="modalShowNameInput"
      :initialRule="this.modeProgram"
      :initialName="this.roundName"
      @confirmed="handleConfirmed"
      @canceled="cancelModal"
  />
  <RoundStatisticsModal
      :visible="roundStatisticsVisible"
      :loading="roundStatisticsLoading"
      :stats="roundStatisticsPayload"
      :error="roundStatisticsError"
      @close="closeRoundStatisticsModal"
  />
</template>

<script>
import SearchBox from "@/components/judging/SearchBox.vue";
import SelectedBox from "@/components/judging/SelectedBox.vue";
import ValidationBox from "@/components/judging/ValidationBox.vue";
import { secureStorage } from "@/services/secureStorage";
import YoutubePlayer from '@/services/YoutubePlayer.vue';
import {mapActions, mapState} from "vuex";
import { fetchStatusUpdate } from "@/helpers/fetchUtils";
import router from "@/router/router";
import {isInnerAthlete,isOwnerAthlete, isOwnerJudgeFromCompetition, isOwnerOrganizer, isSupervisor} from "@/helpers/roleUtils";
import echoService from "@/services/echoService";
import ConfirmationModal from "@/components/competitions/ConfirmationModal.vue";
import JudgeInfo from "@/components/judging/JudgeInfo.vue";
import RoundStatisticsModal from "@/components/competitions/RoundStatisticsModal.vue";
import { normalizeTricklistEntries, readCachedTricklist, writeCachedTricklist } from "@/lib/tricklistVersionCache";

const SCORING_LESS_25 = 0.75;
const SCORING_LESS_50 = 0.5;
const SCORING_LESS_75 = 0.25;
const SCORING_DUB_20 = 0.8;
const SCORING_DUB_50 = 0.5;
const SCORING_DUB_80 = 0.2;
const SCORING_STYLE_PLUS_1 = 1.05;
const SCORING_STYLE_PLUS_2 = 1.10;
const SCORING_STYLE_PLUS_4 = 1.15;
const SCORING_STYLE_PLUS_7 = 1.20;
const SCORING_COMBO_PLUS = 1.5;
const SCORING_COMBO_PLUS_FEET = 1.65;
const SCORING_COMBO_PLUS_6 = 2;
const SCORING_COMBO_PLUS_6_FEET = 2.2;

export default {
  name: "JudgingProgramBox",
  data() {
    return {
      /*Calculos*/
      trickEdit: null,
      trickEditIndex: null,
      trickValidatedEdit: null,
      trickValidatedEditIndex: null,
      trickValidatedEditSubIndex: null,
      comboValidatedEditIndex: null,
      tricks: JSON.parse(secureStorage.getItem('tricks')) || [],
      activeTricklistVersionId: null,
      selectedListTricks:  JSON.parse(secureStorage.getItem('selectedTricks')) || [],
      validatedTricks: JSON.parse(secureStorage.getItem('validatedTricks')) || [],
      comboSelected: [],
      comboCount: JSON.parse(localStorage.getItem('comboCount')) || 1,
      selectedReorderMode: false,
      validatedReorderMode: false,
      totalScorePrint : {
        'style' : '0%',
        'score' : 0,
      },
      scoringDurationText: null,
      /*system*/
      modeProgram: JSON.parse(localStorage.getItem('selectedOption')) || 4,
      round_update : this.roundIdToUpdate,
      round_view : this.roundIdToView,
      videoLink: null,
      videoUrl: JSON.parse(secureStorage.getItem('videoUrl')) || null,
      isExpanded: true,
      isVideoFloating: false,
      isVideoSplit: false,
      isDesktopViewport: false,
      floatingVideoPosition: {
        x: 0,
        y: 0,
      },
      floatingVideoSize: {
        width: 0,
      },
      videoDragState: {
        active: false,
        pointerOffsetX: 0,
        pointerOffsetY: 0,
      },
      videoResizeState: {
        active: false,
        startX: 0,
        startWidth: 0,
      },
      athleteId: null,
      athleteData: null,
      judgeData: null,
      editors: [],
      competitionDetails: JSON.parse(secureStorage.getItem('competitionIdToView')) || [],
      lastRound: null,
      roundName: null,
      trainingType: 'athlete',
      trainingJudgeAlreadyCompleted: false,
      assignedJudgeId: null,
      pendingConfirmResolver: null,
      showCancel: false,
      modalMessage: "",
      modalShowRuleSelector: false,
      modalShowNameInput: false,
      selectedStatus: "",
      selectedRule: "",
      ruleOptions: [
        { id: 1, name: "Without rules" },
        { id: 2, name: "TJS v2.0" },
        { id: 3, name: "TJS v3.0" },
        { id: 4, name: "TJS v4.0" }
      ],
      validatedRound:null,
      roundFeedbackComment: '',
      reviewSessionRoundId: null,
      reviewRestoreStatus: 7,
      reviewRestoreSource: 'judge_panel',
      shouldRevertReview: false,
      pageExitSessionReleaseSent: false,
      scoringSessionRoundId: null,
      scoringRestoreStatus: 21,
      shouldRevertScoring: false,
      trainingJudgeScoringRoundId: null,
      shouldCancelTrainingJudgeScoring: false,
      editSessionRoundId: null,
      editRestoreStatus: 7,
      shouldRevertEdit: false,
      suppressRecalc: false,
      hasServerTotalScore: false,
      validatedTricksDiffs: [],
      editorDiffEvent: null,
      codeInput: '',
      codeStatus: 'idle', // 'idle' | 'valid' | 'invalid'
      codeBusy: false,
      codeError: '',
      codeContextKey: null,
      viewedRoundVerificationCode: null,
      roundStatisticsVisible: false,
      roundStatisticsLoading: false,
      roundStatisticsError: '',
      roundStatisticsPayload: null,
      roundStatisticsRoundId: null,
      // videoUrl: 'https://www.youtube.com/watch?v=qUo7Wnlm260',
      // videoUrl: 'https://www.youtube.com/watch?v=g_Ms0VuN0K4',
    };
  },
  computed: {
    ...mapState("competition",["competitionIdToView","competitionData","appNavigation"]),
    ...mapState("round",["roundAthleteId","roundIdToUpdate","roundIdToView","competitionRounds","roundCompetitionIdToCreate","roundCompetitionIdToView","roundCompetitionIdToEdit"]),
    ...mapState('user', ['isAuthenticated','user','token']),
    ...mapState('training', ['trainingRounds','trainingRoundsIdToView','trainingRoundsIdToCreate','trainingRoundsIdToEdit']),
    totalScore() {
      // let idCheck = this.roundCompetitionIdToCreate || this.roundCompetitionIdToView;
      // const roundSelected = this.competitionRounds.find(r => r.id === idCheck);

      const calculateScore = (tricks) => {
        return tricks.reduce((total, trick) => {
          if (Array.isArray(trick.body)) {
            total += calculateScore(trick.body);
          } else {
            total += trick.score || 0;
          }
          return total;
        }, 0);
      };
      return parseFloat(calculateScore(this.validatedTricks).toFixed(2));
     /* if (roundSelected && [17, 10, 6].includes(roundSelected.status_id)) {
        return parseFloat(calculateScore(this.validatedTricks).toFixed(2));
      } else {
        return '-';
      }*/
    },
    totalTricks() {
      const calculateTricks = (tricks) => {
        return tricks.reduce((total, trick) => {
          if (Array.isArray(trick.body)) {
            total += calculateTricks(trick.body);
          } else {
            total += 1 || 0;
          }
          return total;
        }, 0);
      };
      return calculateTricks(this.validatedTricks);
    },
    countUniqueTrick() {
     /* let idCheck = this.roundCompetitionIdToCreate || this.roundCompetitionIdToView;
      const roundSelected = this.competitionRounds.find(r => r.id === idCheck);*/

      const result = {
        total: 0,
        counter: [],
      };
      const countTricks = (tricks) => {
        tricks.forEach(trick => {
          const key = this.getKeyForTrick(trick);
          if (key !== undefined) {
            if (result.counter.find(existingKey => existingKey === key) === undefined) {
              result.counter.push(key);
              result.total = (result.total || 0) + 1;
            }
          }
          if (Array.isArray(trick.body)) {
            countTricks(trick.body);
          }
        });
      };
      countTricks(this.validatedTricks);
      return result;

      /* if (roundSelected && [17, 10, 6].includes(roundSelected.status_id)) {
         return result;
       }else{
         return {
           total: '-',
           counter: [],
         };
       }*/
    },
    competitionName(){
      return this.competitionData?.name || this.competitionDetails?.name;
    },
    codeInputTrimmed() {
      return (this.codeInput || '').trim();
    },
    isHiddenScore(){
      if (this.roundCompetitionIdToView){
        const roundSelected = this.competitionRounds.find(r => r.id === this.roundCompetitionIdToView);
        if (!roundSelected) return null;

        const isPublished = Number(roundSelected.status_id) === 10;
        const isSelfAthlete = this.isInnerAthlete(this.user, this.athleteData);
        const isPrivileged = this.isOwnerOrganizer(this.user, this.competitionData) || this.isOwnerJudgeFromCompetition(this.user, this.competitionData);

        if (isSelfAthlete && !isPublished) return false;

        return isPublished || isPrivileged;
      }else if(this.trainingRoundsIdToView){
        return true;
      }else if(this.roundCompetitionIdToCreate || this.roundCompetitionIdToEdit){
        return true;
      }else if(this.trainingRoundsIdToCreate){
        return true;
      }else if(this.trainingRoundsIdToEdit){
        return true;
      }else{
        return null;
      }
    },
    isCompetitionCreate(){
      return this.roundCompetitionIdToCreate;
    },
    isCompetitionEdit(){
      return this.roundCompetitionIdToEdit;
    },
    isCompetitionView(){
      return this.trainingRoundsIdToView || this.roundCompetitionIdToView;
    },
    canOpenRoundStatistics() {
      if (!this.roundCompetitionIdToView) return false;
      if (this.trainingRoundsIdToView) return false;
      if (this.isReviewOrView) return false;

      const round = this.currentRound;
      if (!round) return false;

      return [8, 10].includes(Number(round.status_id));
    },
    isReviewOrView() {
      if (!this.roundCompetitionIdToView) return false; // sólo para rounds de competición
      if (!this.isInnerAthlete(this.user, this.athleteData)) return false;
      const round = this.currentRound;
      const allowedStatuses = [7, 11, 12, 19, 22, 23];
      if (!round) return false;
      if (!allowedStatuses.includes(Number(round.status_id))) return false;
      return !this.validatedRound;
    },
    isPublishedRound() {
      const roundId = this.trainingRoundsIdToView || this.roundCompetitionIdToView || this.roundCompetitionIdToEdit;
      if (!roundId) return false;

      const round = this.competitionRounds.find(r => r.id === roundId);
      if (!round) return false;

      // Si el round está publicado o validado, no puede editarse ni verse como dueño/juez
      if (round.status_id === 10) {
        return false;
      }

      if (this.isOwnerAthlete(this.user, round)) {
        return round.validated_at === null ? round : false;
      }
      if (this.isOwnerJudgeFromCompetition(this.user, this.competitionData) && this.roundCompetitionIdToEdit) {
        return round;
      }

      return false;
    },
    feedBackInput(){
      const roundId = this.trainingRoundsIdToView || this.roundCompetitionIdToView;
      if (!roundId) return false;

      const round = this.competitionRounds.find(r => r.id === roundId);
      if (!round) return false;

      // Si el round está publicado o validado, no puede editarse ni verse como dueño/juez
      if (round.status_id === 10) {
        return round;
      }

      // Solo retorna el round si es dueño atleta o juez
      if ((this.isOwnerAthlete(this.user, round) || this.isOwnerJudgeFromCompetition(this.user, this.competitionData)) && round.validated_at !== null) {
        return round;
      }

      return false;
    },
    isRoundCreate(){
      return this.trainingRoundsIdToCreate;
    },
    isRoundEdit(){
      return this.trainingRoundsIdToEdit;
    },
    isJudgeTrainingContext() {
      return Boolean(this.isTraining && this.trainingType === 'judge');
    },
    headerAthleteName() {
      const athlete = this.athleteData || {};
      const fullName = [athlete.name, athlete.surname]
        .filter((value) => typeof value === 'string' && value.trim())
        .join(' ')
        .trim();

      if (fullName) {
        return fullName;
      }

      if (typeof athlete.full_name === 'string' && athlete.full_name.trim()) {
        return athlete.full_name.trim();
      }

      if (typeof athlete.user_id === 'string' && athlete.user_id.trim()) {
        return athlete.user_id.trim();
      }

      return '';
    },
    showTrainingHeaderDetails() {
      return !this.isJudgeTrainingContext;
    },
    isJudgeTrainingFirstSaveMode() {
      return Boolean(this.isRoundEdit && this.trainingType === 'judge' && !this.trainingJudgeAlreadyCompleted);
    },
    canDeleteCurrentVideo() {
      if (this.trainingType === 'judge' && this.isTraining) {
        return this.isSupervisor(this.user);
      }
      return true;
    },
    shouldShowJudgeInfo() {
      const userId = Number(this.user?.id || 0);
      const assignedJudgeId = Number(this.assignedJudgeId || 0);
      const roundJudgeId = Number(this.judgeData?.id || this.judgeData?.user_id || this.judgeData?.user?.id || 0);
      const canSeeJudgeTrainingMeta = this.isSupervisor(this.user) || (userId > 0 && (userId === assignedJudgeId || userId === roundJudgeId));
      const hasMeta = Boolean(this.judgeData || this.scoringDurationText || (Array.isArray(this.editors) && this.editors.length));

      if (this.isJudgeTrainingContext) {
        return Boolean((this.isCompetitionView || this.isRoundEdit) && canSeeJudgeTrainingMeta && hasMeta);
      }

      return Boolean(
        this.isCompetitionView &&
        hasMeta
      );
    },
    judgeInfoData() {
      return this.judgeData || { id: null, name: '-', surname: '' };
    },
    isVideoSplitDesktop() {
      return this.isVideoSplit && this.isDesktopViewport;
    },
    floatingVideoStyle() {
      if (!this.isVideoFloating || this.isVideoSplitDesktop) {
        return {};
      }

      return {
        left: `${this.floatingVideoPosition.x}px`,
        top: `${this.floatingVideoPosition.y}px`,
        width: this.floatingVideoSize.width ? `${this.floatingVideoSize.width}px` : undefined,
      };
    },

    isCompetition(){
      return this.roundCompetitionIdToCreate || this.competitionIdToView;
    },
    isTraining(){
      return this.trainingRoundsIdToCreate || this.trainingRoundsIdToView || this.trainingRoundsIdToEdit;
    },
    isOnlineCompetition() {
      const comp = this.competitionData || this.competitionDetails;
      return Number(comp?.type_id) === 1;
    },
    activeCompetitionRoundId() {
      return this.roundCompetitionIdToView || this.roundCompetitionIdToEdit || this.roundCompetitionIdToCreate || null;
    },
    activeAthleteId() {
      return this.athleteData?.id || this.roundAthleteId || this.athleteId || this.user?.id || null;
    },
    currentRound() {
      if (!this.activeCompetitionRoundId || !Array.isArray(this.competitionRounds)) return null;
      return this.competitionRounds.find((r) => r.id === this.activeCompetitionRoundId) || null;
    },
    roundVerifiedAt() {
      return this.currentRound?.verification_code_verified_at || null;
    },
    requiresRoundCode() {
      return Boolean(this.isOnlineCompetition && this.activeCompetitionRoundId && !this.roundVerifiedAt);
    },
    isCodeLocked() {
      return this.requiresRoundCode && this.codeStatus !== 'valid';
    },
    isCompetitionViewCancel(){
      return this.roundCompetitionIdToView;
    },
    isCompetitionEditCancel(){
      return this.roundCompetitionIdToEdit;
    },

    isCompetitionEditSave(){
      return this.roundCompetitionIdToEdit;
    },
    isCompetitionUpdateSave(){
      return this.roundCompetitionIdToCreate;
    },
    isRoundSave(){
      return this.round_update;
    },

    isView(){
      return this.trainingRoundsIdToView || this.roundCompetitionIdToView;
    },

    findRoundByCompetition(){
      const ids = [
        this.roundCompetitionIdToEdit,
        this.roundCompetitionIdToCreate,
        this.roundCompetitionIdToView
      ].filter(Boolean); // quita los que son null o undefined

      if (!this.competitionRounds?.length || !ids.length) {
        return 1; // valor por defecto
      }

      // Buscamos el primer round que coincida con alguno de los IDs
      const foundRound = this.competitionRounds.find(r => ids.includes(r.id));
      const isDual = this.competitionData?.is_qualification_dual;

      if (foundRound) {
        if(foundRound.round_number === 1){
          return this.$t('judging_program.round_data.qualification') + foundRound.round_number;
        }
        if(foundRound.round_number === 2 && isDual){
          return this.$t('judging_program.round_data.qualification') + foundRound.round_number;
        }else{
          const name = 'judging_program.round_data.stage'+ foundRound.round_size_id;
          return this.$t(name);
        }
      }
      // Si no se encontró, devolvemos el valor máximo como fallback
      return Math.max(...this.competitionRounds.map(r => r.round_number || 1));
    },

    findRoundByTraining() {
      if (this.trainingRounds && this.trainingRounds.length > 0) {
        // Si hay uno en concreto a mostrar
        if (this.trainingRoundsIdToView) {
          const round = this.trainingRounds.find(r => r.id === this.trainingRoundsIdToView);
          if (round) {
            if (round.round_name){
              return round.round_name;
            }else {
              return this.$t('judging_program.round_data.round') + round.round_number
            }
          }
        }

        // Si se está creando uno nuevo
        if (this.trainingRoundsIdToCreate) {
          const lastRound = this.trainingRounds[this.trainingRounds.length - 1];
          if (this.roundName){
            return this.roundName;
          }else {
            return this.$t('judging_program.round_data.round') + (lastRound.round_number + 1);
          }
        }
        // Si se está editando uno nuevo

        if (this.trainingRoundsIdToEdit) {
          const round = this.trainingRounds.find(r => r.id === this.trainingRoundsIdToEdit);
          if (round) {
            if (round.round_name){
              return round.round_name;
            }else {
              return this.$t('judging_program.round_data.round') + round.round_number
            }
          }
        }

        // Default: último round
        const lastRound = this.trainingRounds[this.trainingRounds.length - 1];
        return this.$t('judging_program.round_data.round') + lastRound.round_number;
      }

      return this.$t('judging_program.round_data.round') + 1;
    },
    isReviewReady() {
      const allTricks = this.getAllFlatTricks();

      return allTricks.length > 0 &&
          allTricks.every(t => t.athlete_feedback === 1 || t.athlete_feedback === 2);
    }
  },
  async mounted() {
    const roundIdFromRoute = Number(this.$route?.query?.roundId || this.$route?.params?.roundId);
    if (roundIdFromRoute) {
      await this.setCompetitionRoundIdToView(roundIdFromRoute);
      await this.viewRound(roundIdFromRoute);
    }

    const competitionId = this.competitionIdToView;
    if (competitionId){
      // Paso 2: Escuchar solo eventos relacionados a esta competición
      this.echoChannel = echoService.channel(`competition.${competitionId}`);
      this.echoChannel
          .listen('.PartialCompetitionUpdated', (e) => {
            this.upsertCompetition(e);
          })
          .error(error => {
            console.error('❌ Error en WebSocket:', error);
          });
    }

    if (this.roundCompetitionIdToCreate){
      await this.ensureRoundContextForCreate(this.roundCompetitionIdToCreate);
    }
    if (this.roundCompetitionIdToEdit){
      await this.getRoundToEdit(this.roundCompetitionIdToEdit);
    }
    if (this.roundCompetitionIdToView){
      await this.viewRound(this.roundCompetitionIdToView);
    }
    if (this.trainingRoundsIdToView){
      await this.viewRound(this.trainingRoundsIdToView);
    }
    if (this.trainingRoundsIdToEdit){
      await this.getRoundToEdit(this.trainingRoundsIdToEdit);
    }
    if (this.trainingRoundsIdToCreate){
      this.modeProgram = this.trainingRoundsIdToCreate.selectedRule;
      this.athleteId = this.user.id;
      this.athleteData = this.user;
      this.roundName = this.trainingRoundsIdToCreate.customName;
      this.trainingType = this.trainingRoundsIdToCreate.trainingType || 'athlete';
      this.assignedJudgeId = this.trainingRoundsIdToCreate.assignedJudgeId || null;
    }
    this.calculateTotalWithRules();
    this.initializeReviewSessionGuard();
    this.initializeScoringSessionGuard();
    this.initializeEditSessionGuard();
    this.resetCodeGate();
    this.updateViewportFlags();
    window.addEventListener('resize', this.handleFloatingViewportChange);
    window.addEventListener('pagehide', this.handlePageExitRelease);
    window.addEventListener('beforeunload', this.handlePageExitRelease);
    window.addEventListener('slackline:before-logout', this.handleBeforeLogout);
    window.addEventListener('tricks:updated', this.getTrickListUpdated);
    this.$nextTick(() => {
      this.ensureFloatingVideoSize();
      this.adjustContentHeight();
    });

    /*  this.calculateTotalWithRules();
      if (this.roundIdToUpdate){
        this.editRound(this.roundIdToUpdate || this.roundCompetitionIdToCreate);
      }
      if (this.roundCompetitionIdToEdit){
        console.log('entre a edit');
        this.editRound(this.roundCompetitionIdToEdit);
      }
      if (this.isCompetition){
        console.log('entre a score');
        const roundSelected = this.competitionRounds.find(r => r.id === this.roundCompetitionIdToCreate);
        this.athleteData = roundSelected.user;
        this.competitionDetails = this.competitionData;
        this.modeProgram = this.competitionDetails.rule_id;
      }
      if (this.roundIdToView || this.roundCompetitionIdToView){
        console.log('entre a ver');
        let roundId = this.roundIdToView || this.roundCompetitionIdToView;
        this.viewRound(roundId);
      }*/
    // window.addEventListener('resize', this.adjustContentHeight);

  },
  async beforeRouteLeave(to, from, next) {
    try {
      await this.releaseActiveRoundSessions();
    } catch (error) {
      console.error('❌ Error al revertir la revisión al salir:', error);
    } finally {
      // Marcar que la vista de competición debe refrescar datos completos al regresar
      if (this.competitionIdToView) {
        this.updateAppNavigationZone({
          zone: 'competition',
          data: { needsRefreshOnReturn: true },
        });
      }
      this.clearReviewNavigationMeta();
      this.clearScoringNavigationMeta();
      if (typeof this.disableEditGuard === 'function') {
        this.disableEditGuard();
      }
      next();
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleFloatingViewportChange);
    window.removeEventListener('pagehide', this.handlePageExitRelease);
    window.removeEventListener('beforeunload', this.handlePageExitRelease);
    window.removeEventListener('slackline:before-logout', this.handleBeforeLogout);
    window.removeEventListener('tricks:updated', this.getTrickListUpdated);
    this.stopVideoDrag();
    this.stopVideoResize();
  },
  watch: {
    validatedTricks() {
      if (this.suppressRecalc) return;
      if (this.isView && this.hasServerTotalScore) return;
      this.calculateTotalWithRules()
    },
    async roundCompetitionIdToView(newId, oldId) {
      if (newId === oldId) {
        return;
      }
      if (newId) {
        this.resetRoundContext();
        await this.viewRound(newId);
        this.initializeReviewSessionGuard();
        this.resetCodeGate();
      } else if (oldId) {
        this.resetRoundContext();
        this.resetCodeGate();
      }
    },
    async roundCompetitionIdToEdit(newId, oldId) {
      if (newId === oldId) {
        return;
      }
      if (newId) {
        this.initializeEditSessionGuard();
        this.resetCodeGate();
      } else if (oldId) {
        this.disableEditGuard();
        this.resetCodeGate();
      }
    },
    async roundCompetitionIdToCreate(newId, oldId) {
      if (newId === oldId) {
        return;
      }
      if (newId) {
        this.initializeScoringSessionGuard();
        this.resetCodeGate();
        await this.ensureRoundContextForCreate(newId);
      } else if (oldId) {
        this.disableScoringGuard();
        this.resetCodeGate();
      }
    },
    async trainingRoundsIdToView(newId, oldId) {
      if (newId === oldId) {
        return;
      }
      if (newId) {
        this.resetRoundContext();
        await this.viewRound(newId);
      } else if (oldId) {
        this.resetRoundContext();
      }
      this.resetCodeGate();
    },
    competitionRounds() {
      this.resetCodeGate();
      if (this.roundCompetitionIdToCreate) {
        this.hydrateRoundContextFromStore(this.roundCompetitionIdToCreate);
      }
    },
    async currentRound(newRound, oldRound) {
      if (newRound?.id && newRound?.id !== oldRound?.id) {
        await this.syncTricklistForContext({ round: newRound });
      }
    },
    async competitionDetails(newCompetition) {
      if (this.currentRound || !newCompetition?.id) {
        return;
      }

      await this.syncTricklistForContext({ competitionId: newCompetition.id });
    }
  },
  components: {
    ConfirmationModal,
    SearchBox,
    SelectedBox,
    ValidationBox,
    YoutubePlayer,
    JudgeInfo,
    RoundStatisticsModal
  },
  methods: {
    ...mapActions("competition",["upsertCompetition","updateAppNavigationZone","setCompetitionIdToView","setCompetition"]),
    ...mapActions("round",["clearRoundIdToUpdate","clearRoundIdToView","clearRoundAthleteId","clearCompetitionRoundIdToCreate","clearCompetitionRoundIdToView","clearCompetitionRoundIdToEdit","setCompetitionRoundIdToView","upsertRound"]),
    ...mapActions('training',["setTrainingRounds","setTrainingRoundsIdToView","clearTrainingRoundsIdToView","clearTrainingRoundsIdToCreate","clearTrainingRounds","clearTrainingRoundsIdToEdit"]),
    fetchStatusUpdate,
    isOwnerJudgeFromCompetition,
    isOwnerOrganizer,
    isInnerAthlete,
    isOwnerAthlete,
    isSupervisor,
    async releaseActiveRoundSessions() {
      await this.revertReviewSessionIfNeeded();
      await this.revertScoringSessionIfNeeded();
      await this.cancelTrainingJudgeScoringIfNeeded();
      if (typeof this.revertEditSessionIfNeeded === 'function') {
        await this.revertEditSessionIfNeeded();
      }
    },
    buildPageExitSessionReleases() {
      const releases = [];

      if (this.shouldRevertReview && this.reviewSessionRoundId) {
        releases.push({
          roundId: this.reviewSessionRoundId,
          statusId: this.reviewRestoreStatus || 7,
          source: this.reviewRestoreSource || 'judge_panel',
        });
      }

      if (this.shouldRevertEdit && this.editSessionRoundId) {
        releases.push({
          roundId: this.editSessionRoundId,
          statusId: this.editRestoreStatus || 7,
          source: 'judge_panel',
        });
      }

      return releases.filter((release, index, array) => {
        return array.findIndex((candidate) => candidate.roundId === release.roundId && candidate.statusId === release.statusId) === index;
      });
    },
    sendPageExitStatusRelease(release) {
      if (!release?.roundId || !this.token) {
        return;
      }

      try {
        fetch('/api/status/update', {
          method: 'POST',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify({
            entity: 'rounds',
            id: release.roundId,
            new_status: release.statusId,
            source: release.source || 'judge_panel',
          }),
        }).catch(() => {});
      } catch (error) {
        /* ignore best-effort unload errors */
      }
    },
    handlePageExitRelease() {
      if (this.pageExitSessionReleaseSent) {
        return;
      }

      const releases = this.buildPageExitSessionReleases();
      if (!releases.length) {
        return;
      }

      this.pageExitSessionReleaseSent = true;
      releases.forEach((release) => this.sendPageExitStatusRelease(release));
    },
    handleBeforeLogout(event) {
      if (!this.shouldRevertReview && !this.shouldRevertEdit && !this.shouldRevertScoring && !this.shouldCancelTrainingJudgeScoring) {
        return;
      }

      const pendingTasks = Array.isArray(event?.detail?.pendingTasks) ? event.detail.pendingTasks : null;
      const releaseTask = this.releaseActiveRoundSessions().catch((error) => {
        console.error('❌ Error liberando sesiones antes del logout:', error);
      });

      if (pendingTasks) {
        pendingTasks.push(releaseTask);
      }
    },
    hydrateRoundContextFromStore(roundId) {
      if (!roundId || !Array.isArray(this.competitionRounds)) return false;
      const round = this.competitionRounds.find((r) => r.id === roundId);
      if (!round) return false;

      this.athleteData = round.user || this.athleteData;
      this.judgeData = round.judge || this.judgeData;
      this.videoUrl = round.video_link || this.videoUrl;
      this.competitionDetails = this.competitionData || round.competition || this.competitionDetails;
      this.modeProgram = round.rule_id || this.competitionDetails?.rule_id || this.modeProgram;
      this.viewedRoundVerificationCode = round.verification_code || this.viewedRoundVerificationCode;
      if (round.verification_code_verified_at && this.codeStatus !== 'valid') {
        this.codeStatus = 'valid';
      }
      return true;
    },
    async openRoundStatistics() {
      const roundId = this.roundCompetitionIdToView;
      if (!roundId) {
        return;
      }

      this.roundStatisticsVisible = true;
      this.roundStatisticsError = '';

      if (this.roundStatisticsRoundId === roundId && this.roundStatisticsPayload) {
        return;
      }

      this.roundStatisticsLoading = true;
      this.roundStatisticsPayload = null;

      try {
        const response = await this.$axios.get(`/rounds/${roundId}/stats`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        this.roundStatisticsPayload = response?.data?.stats || null;
        this.roundStatisticsRoundId = roundId;
      } catch (error) {
        console.error('Error al cargar las estadísticas de la ronda:', error);
        this.roundStatisticsError = error?.response?.data?.message || 'No se pudieron cargar las estadísticas de la ronda.';
      } finally {
        this.roundStatisticsLoading = false;
      }
    },
    closeRoundStatisticsModal() {
      this.roundStatisticsVisible = false;
      this.roundStatisticsError = '';
    },
    async ensureRoundContextForCreate(roundId) {
      const hydrated = this.hydrateRoundContextFromStore(roundId);
      const hasCode = this.currentRound?.verification_code || this.viewedRoundVerificationCode;
      if (hydrated && hasCode) return;

      try {
        const response = await this.$axios.get(`/get_round/${roundId}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        const round = response?.data?.round;
        if (!round) return;

        this.viewedRoundVerificationCode = round.verification_code || this.viewedRoundVerificationCode;
        await this.upsertRound(round);
        this.hydrateRoundContextFromStore(roundId);
      } catch (error) {
        console.error('No se pudo cargar la ronda para calificar', error);
      }
    },
    resetCodeGate() {
      const nextKey = this.requiresRoundCode && this.activeCompetitionRoundId
        ? `${this.activeCompetitionRoundId}:${this.roundVerifiedAt || ''}`
        : null;

      if (!this.requiresRoundCode) {
        this.codeStatus = 'valid';
        this.codeError = '';
        this.codeBusy = false;
        this.codeContextKey = null;
        return;
      }

      if (this.codeStatus === 'valid' && this.codeContextKey === nextKey) {
        return;
      }

      this.codeContextKey = nextKey;
      this.codeStatus = 'idle';
      this.codeError = '';
      this.codeBusy = false;
      this.codeInput = '';
    },
    handleCodeInput(event) {
      const rawValue = event?.target?.value || '';
      this.codeInput = rawValue.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
    },
    async validateVerificationCode() {
      if (!this.requiresRoundCode) {
        this.codeStatus = 'valid';
        return;
      }

      const roundId = this.activeCompetitionRoundId;
      const code = this.codeInputTrimmed;
      if (!roundId) {
        this.codeStatus = 'invalid';
        this.codeError = this.$t?.('judging_program.round_video_box.code_validator_missing_round') || 'Round no disponible para validar.';
        return;
      }
      if (!code) {
        this.codeStatus = 'invalid';
        this.codeError = this.$t?.('judging_program.round_video_box.code_validator_required') || 'Ingresa el código mostrado en el video.';
        return;
      }

      this.codeBusy = true;
      this.codeError = '';

      try {
        const { data } = await this.$axios.post(`/rounds/${roundId}/verify-code`, {
          verification_code: code
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        const valid = data?.valid === true || data?.success === true;
        if (valid) {
          this.codeStatus = 'valid';
          this.codeError = '';
          const verifiedAt = data?.verified_at || new Date().toISOString();
          this.codeContextKey = `${roundId}:${verifiedAt}`;
          await this.upsertRound({ id: roundId, verification_code_verified_at: verifiedAt });
        } else {
          this.codeStatus = 'invalid';
          this.codeError = this.$t?.('judging_program.round_video_box.code_validator_error') || 'Código incorrecto. Intenta nuevamente.';
        }
      } catch (err) {
        const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message;
        this.codeStatus = 'invalid';
        this.codeError = msg || (this.$t?.('judging_program.round_video_box.code_validator_error') || 'Código incorrecto. Intenta nuevamente.');
      } finally {
        this.codeBusy = false;
      }
    },
    initializeReviewSessionGuard() {
      if (this.shouldRevertReview && !this.reviewSessionRoundId && this.roundCompetitionIdToView) {
        this.reviewSessionRoundId = this.roundCompetitionIdToView;
        return;
      }
      if (this.shouldRevertReview) {
        return;
      }

      const navigationMeta = this.appNavigation?.competition || {};
      if (!navigationMeta.cameFromReviewRound) {
        return;
      }

      if (this.roundCompetitionIdToView) {
        this.reviewSessionRoundId = this.roundCompetitionIdToView;
      }
      this.reviewRestoreStatus = navigationMeta.reviewRoundRestoreStatus || 7;
      this.reviewRestoreSource = navigationMeta.reviewRoundRestoreSource || 'judge_panel';
      this.shouldRevertReview = true;
      this.updateAppNavigationZone({
        zone: "competition",
        data: {
          cameFromReviewRound: false,
          reviewRoundRestoreStatus: null,
          reviewRoundRestoreSource: null,
        },
      });
    },
    async revertReviewSessionIfNeeded() {
      if (!this.shouldRevertReview || !this.reviewSessionRoundId) {
        return;
      }

      const targetStatus = this.reviewRestoreStatus || 7;
      try {
        // Al salir de la vista de review volvemos a 7 usando la misma fuente con la que llegamos
        await this.fetchStatusUpdate(this.token, 'rounds', this.reviewSessionRoundId, targetStatus, this.reviewRestoreSource || 'judge_panel');
      } finally {
        this.shouldRevertReview = false;
        this.reviewSessionRoundId = null;
      }
    },
    clearReviewNavigationMeta() {
      const navigationMeta = this.appNavigation?.competition || {};
      if (navigationMeta.cameFromReviewRound || navigationMeta.reviewRoundRestoreStatus) {
        this.updateAppNavigationZone({
          zone: "competition",
          data: {
            cameFromReviewRound: false,
            reviewRoundRestoreStatus: null,
            reviewRoundRestoreSource: null,
          },
        });
      }
    },
    initializeScoringSessionGuard() {
      if (this.shouldRevertScoring && !this.scoringSessionRoundId && this.roundCompetitionIdToCreate) {
        this.scoringSessionRoundId = this.roundCompetitionIdToCreate;
        return;
      }
      if (this.shouldRevertScoring) {
        return;
      }

      if (!this.roundCompetitionIdToCreate) {
        return;
      }

      this.scoringSessionRoundId = this.roundCompetitionIdToCreate;
      this.scoringRestoreStatus = 21;
      this.shouldRevertScoring = true;
    },
    async revertScoringSessionIfNeeded() {
      if (!this.shouldRevertScoring || !this.scoringSessionRoundId) {
        return;
      }

      try {
        await this.fetchStatusUpdate(this.token, 'rounds', this.scoringSessionRoundId, this.scoringRestoreStatus, 'judge_panel');
      } catch (error) {
        console.error('❌ Error al revertir la calificación al salir:', error);
      } finally {
        this.resetScoringDraftState();
        this.disableScoringGuard();
      }
    },
    disableScoringGuard() {
      this.shouldRevertScoring = false;
      this.scoringSessionRoundId = null;
    },
    clearScoringNavigationMeta() {
      const navigationMeta = this.appNavigation?.competition || {};
      if (navigationMeta.cameFromScoreRound || navigationMeta.scoreRoundRestoreStatus) {
        this.updateAppNavigationZone({
          zone: "competition",
          data: {
            cameFromScoreRound: false,
            scoreRoundRestoreStatus: null,
          },
        });
      }
    },
    initializeEditSessionGuard() {
      if (this.shouldRevertEdit && !this.editSessionRoundId && this.roundCompetitionIdToEdit) {
        this.editSessionRoundId = this.roundCompetitionIdToEdit;
        return;
      }
      if (this.shouldRevertEdit) {
        return;
      }

      if (!this.roundCompetitionIdToEdit) {
        return;
      }

      this.editSessionRoundId = this.roundCompetitionIdToEdit;
      this.editRestoreStatus = 7;
      this.shouldRevertEdit = true;
    },
    async revertEditSessionIfNeeded() {
      if (!this.shouldRevertEdit || !this.editSessionRoundId) {
        return;
      }

      try {
        await this.fetchStatusUpdate(this.token, 'rounds', this.editSessionRoundId, this.editRestoreStatus, 'judge_panel');
      } catch (error) {
        console.error('❌ Error al revertir la edición al salir:', error);
      } finally {
        this.disableEditGuard();
      }
    },
    disableEditGuard() {
      this.shouldRevertEdit = false;
      this.editSessionRoundId = null;
    },
    resetScoringDraftState() {
      this.validatedTricks = [];
      this.selectedListTricks = [];
      this.comboSelected = [];
      this.comboCount = 1;
      this.totalScorePrint = {
        'style': '0%',
        'score': 0,
      };
      this.validatedTricksDiffs = [];
      localStorage.removeItem('validatedTricks');
      localStorage.removeItem('selectedTricks');
      localStorage.removeItem('comboCount');
      localStorage.removeItem('videoUrl');
      this.videoUrl = null;
      this.clearRoundIdToUpdate();
      this.clearRoundAthleteId();
      this.clearCompetitionRoundIdToCreate();
    },
    /*Components*/
    clearSelectedTricks() {
      this.selectedListTricks = [];
      this.comboValidatedEditIndex= null;
      localStorage.removeItem('selectedTricks');
    },
    handleUpdateSelectedTricks(trickEditIndex,updatedTricks) {
      if (trickEditIndex !== null && trickEditIndex !== undefined && trickEditIndex >= 0 && trickEditIndex < this.selectedListTricks.length) {
        this.selectedListTricks.splice(trickEditIndex, 1, updatedTricks);
        this.trickEdit= null;
        this.trickEditIndex= null;
      } else {
        // Si trickEditIndex no tiene un valor válido, agregar el truco al final del array
        this.selectedListTricks = [...this.selectedListTricks, updatedTricks];
      }
      secureStorage.setItem('selectedTricks', JSON.stringify(this.selectedListTricks));
    },
    handleUpdateValidatedTricks(trickValidatedEditIndex, trickValidatedEditSubIndex, updatedTricks) {
      if (trickValidatedEditIndex !== null && trickValidatedEditIndex !== undefined && trickValidatedEditIndex >= 0 && trickValidatedEditIndex < this.validatedTricks.length) {
        if (trickValidatedEditSubIndex !== null && trickValidatedEditSubIndex !== undefined) {
          const trickToUpdate = this.validatedTricks[trickValidatedEditIndex].body[trickValidatedEditSubIndex];
          if (trickToUpdate) {
            Object.assign(trickToUpdate, updatedTricks);
            this.calculateTotalWithRules();
          }
        } else {
          this.validatedTricks[trickValidatedEditIndex] = updatedTricks;
          this.calculateTotalWithRules();
        }

        this.trickValidatedEdit = null;
        this.trickValidatedEditIndex = null;
        this.trickValidatedEditSubIndex = null;
      } else {
        // Si trickEditIndex no tiene un valor válido, agregar el truco al final del array
        this.validatedTricks = [...this.validatedTricks, updatedTricks];
        this.calculateTotalWithRules();
      }
      secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
    },
    // Para cuando estén todos confirmados
    handleAllTricksConfirmed() {
      this.allConfirmed = true;
    },

    confirmAllFeedbacksFromParent() {
      // Dispará desde un botón padre: marca todos como confirmados
      this.$refs.validatedBox.markAllConfirmed();
    },
    handleUpdateAllValidatedTricks(updatedTricks) {
      this.validatedTricks = updatedTricks;
      this.calculateTotalWithRules();
      secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
    },
    handleCancelTrickEdit() {
      this.trickEdit = null;
      this.trickEditIndex = null;
      this.trickValidatedEdit = null;
      this.trickValidatedEditIndex = null;
      this.trickValidatedEditSubIndex = null;
    },
    handleReorderSelectedTricks(newOrder) {
      this.selectedListTricks = [...newOrder];
      secureStorage.setItem('selectedTricks', JSON.stringify(this.selectedListTricks));
    },
    handleReorderModeChanged(isActive) {
      this.selectedReorderMode = Boolean(isActive);
    },
    handleValidatedReorderModeChanged(isActive) {
      this.validatedReorderMode = Boolean(isActive);
    },
    getAllFlatTricks() {
      const all = [];

      for (const trick of this.validatedTricks) {
        if (Object.prototype.hasOwnProperty.call(trick, 'header') && Object.prototype.hasOwnProperty.call(trick, 'body')) {
          // Es combo → agregamos sus subtricks
          for (const subTrick of trick.body) {
            all.push(subTrick);
          }
        } else {
          all.push(trick); // Trick normal
        }
      }

      return all;
    },
    deleteTrickSelected(index) {
      // Actualizar el array sin mutar directamente la prop
      this.selectedListTricks = this.selectedListTricks.filter((_, i) => i !== index);
      secureStorage.setItem('selectedTricks', JSON.stringify(this.selectedListTricks));
    },
    updateTrickSelected(index){
      this.trickEdit = { ...this.selectedListTricks[index] };
      this.trickEditIndex = index;
      this.$refs.searchFocus.focus();
      this.scrollToElement('cardSearchTutorial');
    },
    deleteTrickValidated(index, subIndex) {
      if (index >= 0 && index < this.validatedTricks.length) {
        if (subIndex >= 0){
          this.validatedTricks[index].body = this.validatedTricks[index].body.filter((trick, i) => {
            const shouldKeep = i !== subIndex;
            if (!shouldKeep) {
              this.$nextTick(() => {
                if (this.validatedTricks[index].body.length === 1){
                  // Mover el elemento 0 del body a validatedTricks
                  const trickToMove = this.validatedTricks[index].body[0];
                  delete trickToMove.combo_id;
                  this.validatedTricks[index] = trickToMove;
                  delete this.validatedTricks[index].body;
                  delete this.validatedTricks[index].header;
                  this.calculateTotalWithRules();
                }else{
                  this.validatedTricks[index].header.total_tricks_combo = this.validatedTricks[index].body.length ;
                  this.validatedTricks[index].header.total_score = this.validatedTricks[index].body.reduce((total, trick) => total + trick.score, 0);
                }
              });
            }
            return shouldKeep;
          });
        }else{
          this.validatedTricks = this.validatedTricks.filter((_, i) => i !== index);
        }
        this.$nextTick(() => {
          secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
        });

      }
    },
    updateTrickValidated(index, subIndex){
      if (index >= 0 && index < this.validatedTricks.length) {
        if (subIndex >= 0){
          this.trickValidatedEdit = { ...this.validatedTricks[index].body[subIndex] };
          this.trickValidatedEditIndex = index;
          this.trickValidatedEditSubIndex = subIndex;
        }else{
          if ('body' in this.validatedTricks[index]){
            this.selectedListTricks = this.validatedTricks[index].body;
            this.comboValidatedEditIndex = index;
          }else{
            this.trickValidatedEdit = { ...this.validatedTricks[index] };
            this.trickValidatedEditIndex = index;
          }
        }
        this.$nextTick(() => {
          this.$refs.searchFocus.focus();
          this.scrollToElement('cardSearchTutorial');
          secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
        });
      }

    },
    async clearLocalStorage() {
      const isConfirmed = await this.confirmWithModal('Are you sure you want to clear all validated tricks?');

      if (isConfirmed) {
        this.validatedTricks = [];
        this.selectedListTricks = [];
        this.comboSelected = [];
        this.comboCount = 1;
        this.totalScorePrint = {
          'style' : '0%',
          'score' : 0,
        };
        this.validatedTricksDiffs = [];
        localStorage.removeItem('validatedTricks');
        localStorage.removeItem('selectedTricks');
        localStorage.removeItem('comboCount');
        // this.$emit('clear-validated-tricks');
      }
    },
    async cancelCreateRound(round) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token, 'rounds', round, 21, 'judge_panel');
      if (response.data?.success) {
        this.validatedTricks = [];
        this.selectedListTricks = [];
        this.comboSelected = [];
        this.comboCount = 1;
        this.totalScorePrint = {
          'style': '0%',
          'score': 0,
        };
        this.validatedTricksDiffs = [];
        localStorage.removeItem('validatedTricks');
        localStorage.removeItem('selectedTricks');
        localStorage.removeItem('comboCount');
        localStorage.removeItem('videoUrl');
        this.videoUrl = null;
        this.clearRoundIdToUpdate();
        this.clearRoundIdToView();
        this.clearRoundAthleteId();
        this.hideLoading();
        if (this.competitionIdToView) {
          this.clearCompetitionRoundIdToCreate();
          this.clearCompetitionRoundIdToEdit();
          this.round_update = false;
          this.round_view = false;
          await router.push('/competitionView');
        } else {
          this.round_update = false;
          this.round_view = false;
          this.clearTrainingRoundsIdToView();
          this.clearTrainingRoundsIdToCreate();
          this.clearTrainingRoundsIdToEdit();
          await router.push('/home');
        }
        this.disableScoringGuard();
        this.clearScoringNavigationMeta();
      } else {
        console.log('⚠️ Falló');
        this.hideLoading();
      }

    },
    async cancelEditRound(round) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token, 'rounds', round, 7, 'judge_panel');
      if (response.data?.success) {
        this.validatedTricks = [];
        this.selectedListTricks = [];
        this.comboSelected = [];
        this.comboCount = 1;
        this.totalScorePrint = {
          'style': '0%',
          'score': 0,
        };
        this.validatedTricksDiffs = [];
        localStorage.removeItem('validatedTricks');
        localStorage.removeItem('selectedTricks');
        localStorage.removeItem('comboCount');
        localStorage.removeItem('videoUrl');
        this.videoUrl = null;
        this.clearRoundIdToUpdate();
        this.clearRoundIdToView();
        this.clearRoundAthleteId();
        this.hideLoading();
        if (this.competitionIdToView) {
          this.clearCompetitionRoundIdToCreate();
          this.clearCompetitionRoundIdToEdit();
          this.round_update = false;
          this.round_view = false;
          await router.push('/competitionView');
        } else {
          this.round_update = false;
          this.round_view = false;
          await router.push('/home');
        }
        this.disableScoringGuard();
        this.disableEditGuard();
        this.clearScoringNavigationMeta();
      } else {
        console.log('⚠️ Falló');
        this.hideLoading();
      }

    },
    async createScoreRound() {
      const isConfirmed = await this.confirmWithModal('Are you sure you want to score the round?');
      if (isConfirmed) {
        try {
          this.showLoading();
          let round_id = this.roundCompetitionIdToCreate;

          const response = await this.$axios.post(`/update_round`, {
            modeProgram: this.modeProgram,
            validatedTricks: this.validatedTricks,
            totalScorePrint: this.totalScorePrint,
            countUniqueTrick: this.countUniqueTrick.total,
            totalScore: this.totalScore,
            roundId: round_id,
            videoUrl: this.videoUrl,
            isNew: true,
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
          if (response.status === 200){
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.comboCount = 1;
            this.totalScorePrint = {
              'style' : '0%',
              'score' : 0,
            };
            this.validatedTricksDiffs = [];
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');

            // this.$emit('clear-validated-tricks');
            this.hideLoading();
            this.round_update = false;
            if (this.competitionIdToView){
              this.clearCompetitionRoundIdToCreate();
              this.clearCompetitionRoundIdToEdit();
              await router.push('/competitionView');
            }else{
              localStorage.removeItem('competitionIdToView');
              await router.push('/home');
            }
            this.disableScoringGuard();
            this.clearScoringNavigationMeta();
          }
        } catch (error) {
          console.error('Error al guardar trucos validados:', error);
        }
      }
    },
    async editScoreRound() {
      const isConfirmed = await this.confirmWithModal('Are you sure you want to edit the round?');
      if (isConfirmed) {
        try {
          this.showLoading();
          let round_id = this.roundCompetitionIdToEdit;

          const response = await this.$axios.post(`/update_round`, {
            modeProgram: this.modeProgram,
            validatedTricks: this.validatedTricks,
            totalScorePrint: this.totalScorePrint,
            countUniqueTrick: this.countUniqueTrick.total,
            totalScore: this.totalScore,
            roundId: round_id,
            athlete_feedback: this.roundFeedbackComment,
            videoUrl: this.videoUrl,
            isNew: false,
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
          if (response.status === 200){
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.comboCount = 1;
            this.totalScorePrint = {
              'style' : '0%',
              'score' : 0,
            };
            this.validatedTricksDiffs = [];
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');

            // this.$emit('clear-validated-tricks');
            this.hideLoading();
            this.round_update = false;
            if (this.competitionIdToView){
              this.clearCompetitionRoundIdToCreate();
              this.clearCompetitionRoundIdToEdit();
              await router.push('/competitionView');
            }else{
              localStorage.removeItem('competitionIdToView');
              await router.push('/home');
            }
          }
        } catch (error) {
          console.error('Error al guardar trucos validados:', error);
        }
      }
    },
    async getRoundToEdit(roundId) {
      try {
        this.showLoading();
        const response = await this.$axios.get(`/get_round/${roundId}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        if (response.status === 200){
          this.selectedListTricks = [];
          this.comboSelected = [];
          this.comboCount = 1;
          localStorage.removeItem('selectedTricks');
          localStorage.removeItem('comboCount');
          localStorage.removeItem('videoUrl');
          const responseRound = response.data.round;
          this.viewedRoundVerificationCode = responseRound?.verification_code || null;
          this.validatedTricksDiffs = this.normalizeDiffPayload(response.data.validated_tricks_diffs);
          const diffByKey = this.buildDiffIndexMap(this.validatedTricksDiffs);
          this.validatedTricks = this.attachDiffsToTricks(response.data.validatedTricks, diffByKey);
          this.videoUrl = responseRound.video_link;
          this.modeProgram = responseRound.rule_id;
          await this.syncTricklistForContext({ round: responseRound });
          this.athleteData = responseRound.user;
          this.judgeData = responseRound.judge;
          this.trainingType = responseRound.training_type || this.trainingType || 'athlete';
          this.trainingJudgeAlreadyCompleted = Boolean(responseRound.already_completed || responseRound.completed_scoring_at);
          this.assignedJudgeId = responseRound.assigned_judge_id || this.assignedJudgeId || null;
          this.roundName = response.data.round_name;
          this.roundFeedbackComment = responseRound.athlete_feedback || '';
          this.scoringDurationText = this.calculateScoringDuration(
            responseRound.started_scoring_at,
            responseRound.completed_scoring_at
          );
          await this.startTrainingJudgeScoringIfNeeded(responseRound);
          secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
          secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
          this.hideLoading();
        }
      } catch (error) {
        console.error('Error al guardar trucos validados:', error);
      }
    },
    async cancelViewRound() {
        const round = this.currentRound;
        const navigationMeta = this.appNavigation?.competition || {};
        const cameFromJudgePanel = Boolean(navigationMeta.cameFromJudgingManual);

        // Solo restaurar selección de ronda/etapa si no venimos desde la tabla de jueces
        if (this.competitionIdToView && round && !cameFromJudgePanel) {
          const navData = {
            cameFromViewRound: true,
            selectedStage: round.round_size_id || null,
            selectedRound: round.round_size_id ? null : round.round_number || null,
            needsRefreshOnReturn: true,
          };
          this.updateAppNavigationZone({ zone: 'competition', data: navData });
        } else if (this.competitionIdToView && cameFromJudgePanel) {
          this.updateAppNavigationZone({
            zone: 'competition',
            data: {
              cameFromJudgingManual: true,
              stageName: navigationMeta.stageName || null,
              roundNumber: navigationMeta.roundNumber || null,
              needsRefreshOnReturn: true,
            },
          });
        }
      this.showLoading();
      await this.cancelTrainingJudgeScoringIfNeeded();
      this.validatedTricks = [];
      this.selectedListTricks = [];
      this.comboSelected = [];
      this.comboCount = 1;
      this.totalScorePrint = {
        'style': '0%',
        'score': 0,
      };
      this.validatedTricksDiffs = [];
      localStorage.removeItem('validatedTricks');
      localStorage.removeItem('selectedTricks');
      localStorage.removeItem('comboCount');
      localStorage.removeItem('videoUrl');
      this.videoUrl = null;
      this.clearRoundIdToUpdate();
      this.clearRoundIdToView();
      this.clearRoundAthleteId();
      this.hideLoading();
      if (this.competitionIdToView) {
        this.clearCompetitionRoundIdToView();
        this.clearCompetitionRoundIdToCreate();
        this.clearCompetitionRoundIdToEdit();
        this.round_update = false;
        this.round_view = false;
        await router.push('/competitionView');
      } else {
        this.round_update = false;
        this.round_view = false;
        this.clearTrainingRoundsIdToView();
        this.clearTrainingRoundsIdToCreate();
        this.clearTrainingRoundsIdToEdit();
        await router.push('/training');
      }
    },
    async reviewRound() {
      const isConfirmed = await this.confirmWithModal('Are you sure you want to Review the round?');

      if (isConfirmed) {
        try {
          this.showLoading();

          const allTricks = this.getAllFlatTricks();
          const feedbacksToSubmit = allTricks.map(trick => ({
            trick_id: trick.validated_trick_id,
            feedback: trick.athlete_feedback,
            comment: trick.athlete_comment || null,
          }));

          const roundId = this.trainingRoundsIdToView || this.roundCompetitionIdToView;

          const response = await this.$axios.post(`/validated_tricks/review`, {
            reviewedTricks: feedbacksToSubmit,
            round_feedback: {
              round_id: roundId,
              comment: this.roundFeedbackComment || null,
            },
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
          if (response.status === 200){
            this.shouldRevertReview = false;
            this.reviewSessionRoundId = null;
            this.clearReviewNavigationMeta();
            if (this.isInnerAthlete(this.user,this.athleteData) && this.roundCompetitionIdToView){
              await this.$axios.get(`/finish_review/${this.roundCompetitionIdToView}`, {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              });
            }
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.comboCount = 1;
            this.totalScorePrint = {
              'style': '0%',
              'score': 0,
            };
            this.validatedTricksDiffs = [];
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');
            this.videoUrl = null;
            this.clearRoundIdToUpdate();
            this.clearRoundIdToView();
            this.clearRoundAthleteId();
            this.hideLoading();
            if (this.competitionIdToView) {
              this.clearCompetitionRoundIdToView();
              this.clearCompetitionRoundIdToCreate();
              this.clearCompetitionRoundIdToEdit();
              this.round_update = false;
              this.round_view = false;
              await router.push('/competitionView');
            } else {
              this.round_update = false;
              this.round_view = false;
              this.clearTrainingRoundsIdToView();
              this.clearTrainingRoundsIdToCreate();
              this.clearTrainingRoundsIdToEdit();
              await router.push('/training');
            }
          }
        } catch (error) {
          this.hideLoading();
          console.error('Error al guardar trucos validados:', error);
        }
      }

    },
    async viewRound(roundId) {
      try {
        this.showLoading();
        this.hasServerTotalScore = false;
        const response = await this.$axios.get(`/get_round/${roundId}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        if (response.status === 200){
          this.selectedListTricks = [];
          this.comboSelected = [];
          this.comboCount = 1;
          localStorage.removeItem('selectedTricks');
          localStorage.removeItem('comboCount');
          localStorage.removeItem('videoUrl');
          const responseRound = response.data.round;
          this.viewedRoundVerificationCode = responseRound?.verification_code || null;
          this.validatedTricksDiffs = this.normalizeDiffPayload(response.data.validated_tricks_diffs);
          this.editors = Array.isArray(response.data.editors)
            ? response.data.editors
            : Array.isArray(responseRound?.editors)
              ? responseRound.editors
              : [];

          // Fusionar con lo que ya está en store para no perder contadores de feedback cuando solo se visualiza
          let roundToUpsert = responseRound;
          const existingRound = this.competitionRounds.find(r => r.id === responseRound.id);
          if (existingRound) {
            roundToUpsert = {
              ...existingRound,
              ...responseRound,
              negative_feedback_count: responseRound.negative_feedback_count ?? existingRound.negative_feedback_count,
              has_feedback: responseRound.has_feedback ?? existingRound.has_feedback,
            };
          }

          // Asegura contexto de round en el store si entramos desde notificación
          const isCompetitionRound = Boolean(responseRound.competition_id);
          if (isCompetitionRound) {
            if (!this.roundCompetitionIdToView) {
              await this.setCompetitionRoundIdToView(responseRound.id);
            }
            if (!this.competitionRounds.find(r => r.id === responseRound.id)) {
              await this.upsertRound(roundToUpsert);
            } else {
              await this.upsertRound(roundToUpsert);
            }
          } else {
            await this.clearCompetitionRoundIdToView();
            if (!this.trainingRoundsIdToView) {
              await this.setTrainingRoundsIdToView(responseRound.id);
            }
          }

          // Setear datos base del round
          this.athleteData = responseRound.user;
          this.validatedRound = responseRound.validated_at;
          this.judgeData = responseRound.judge;
          this.trainingType = responseRound.training_type || this.trainingType || 'athlete';
          this.trainingJudgeAlreadyCompleted = Boolean(responseRound.already_completed || responseRound.completed_scoring_at);
          this.assignedJudgeId = responseRound.assigned_judge_id || this.assignedJudgeId || null;
          this.scoringDurationText = this.calculateScoringDuration(
            responseRound.started_scoring_at,
            responseRound.completed_scoring_at
          );
          this.suppressRecalc = true;
          const diffByKey = this.buildDiffIndexMap(this.validatedTricksDiffs);
          this.validatedTricks = this.attachDiffsToTricks(response.data.validatedTricks || [], diffByKey);
          const totalFromServer = responseRound.total_score ?? response.data.totalScore;
          if (totalFromServer !== undefined) {
            this.totalScorePrint.score = parseFloat(totalFromServer).toFixed(2);
            this.hasServerTotalScore = true;
          }
          this.$nextTick(() => { this.suppressRecalc = false; });
          this.videoUrl = responseRound.video_link;
          this.modeProgram = responseRound.rule_id;
          await this.syncTricklistForContext({ round: responseRound });
          this.roundFeedbackComment = responseRound.athlete_feedback || '';
          this.round_view = true;
          this.round_update = false;

          // Si hay datos de competición, persistir contexto para encabezados/botones
          const competitionId = responseRound.competition_id || responseRound?.competition?.id;
          const competitionObj = responseRound.competition || null;
          this.viewedRoundVerificationCode = responseRound.verification_code || null;
          if (competitionId && !this.competitionIdToView) {
            await this.setCompetitionIdToView(competitionId);
          }
          if (competitionObj) {
            await this.setCompetition(competitionObj);
            await this.upsertCompetition(competitionObj);
            this.competitionDetails = competitionObj;
            this.modeProgram = competitionObj.rule_id || this.modeProgram;
          } else if (competitionId && (!this.competitionDetails || !Object.keys(this.competitionDetails).length)) {
            await this.fetchCompetitionDetails(competitionId);
          }

          // Si es el propio atleta y la ronda no está validada, y está en 7 (pendiente de review), pasa a 19
          if (this.isInnerAthlete(this.user, this.athleteData) && !this.validatedRound && responseRound.status_id === 7) {
            try {
              await this.fetchStatusUpdate(this.token, 'rounds', responseRound.id, 19, null);
              // Preparar guard para revertir al salir si llegamos desde notificación
              this.reviewSessionRoundId = responseRound.id;
              this.reviewRestoreStatus = 7;
              this.reviewRestoreSource = null;
              this.shouldRevertReview = true;
              this.updateAppNavigationZone({
                zone: 'competition',
                data: {
                  cameFromReviewRound: true,
                  reviewRoundRestoreStatus: 7,
                  reviewRoundRestoreSource: null,
                },
              });
            } catch (err) {
              console.warn('No se pudo actualizar estado a review', err);
            }
          }

          secureStorage.setItem('validatedTricks', JSON.stringify(this.validatedTricks));
          secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
          await this.startTrainingJudgeScoringIfNeeded(responseRound);
          this.hideLoading();
        }

      } catch (error) {
        console.error('Error al guardar trucos validados:', error);
      }

    },
    normalizeDiffPayload(rawDiffs) {
      const normalizeIndex = (value, fallback = null) => {
        const toInt = (v) => {
          const n = Number(v);
          return Number.isInteger(n) ? n : null;
        };

        const primary = toInt(value);
        if (primary !== null) return primary;

        const secondary = toInt(fallback);
        if (secondary !== null) return secondary;

        return null;
      };

      if (!Array.isArray(rawDiffs)) return [];

      return rawDiffs.map((diff) => {
        const normalizedAction = (diff?.change_type || diff?.action || (diff?.before ? 'edited' : 'added')) || 'edited';
        const normalizedIndex = normalizeIndex(diff?.index, diff?.trick_index);
        const normalizedFromIndex = normalizeIndex(diff?.from_index, diff?.fromIndex);

        return {
          ...diff,
          action: normalizedAction,
          change_type: normalizedAction,
          index: normalizedIndex,
          from_index: normalizedFromIndex,
          trick_entry_id: diff?.trick_entry_id || diff?.trickId || diff?.trick_id || null,
        };
      });
    },
    buildDiffIndexMap(diffs) {
      const pickLatest = (candidate, existing) => {
        const candTs = new Date(candidate.edited_at || candidate.updated_at || candidate.created_at || 0).getTime();
        const currTs = new Date(existing.edited_at || existing.updated_at || existing.created_at || 0).getTime();
        if (!Number.isNaN(candTs) && !Number.isNaN(currTs)) {
          return candTs >= currTs ? candidate : existing;
        }
        return candidate;
      };

      const addKey = (acc, key, item) => {
        if (!key) return;
        const current = acc[key];
        acc[key] = current ? pickLatest(item, current) : item;
      };

      const toInt = (v) => {
        const n = Number(v);
        return Number.isInteger(n) ? n : null;
      };

      return (Array.isArray(diffs) ? diffs : []).reduce((acc, item) => {
        const idRaw = item.trick_entry_id
          ?? item.validated_trick_entry_id
          ?? item.validated_trick_id
          ?? item.trick_id
          ?? item.id;
        const idxCandidates = [item.index, item.trick_index, item.from_index, item.index_before, item.index_after]
          .map(toInt)
          .filter((v) => Number.isInteger(v));

        const idKey = idRaw !== undefined && idRaw !== null ? `id:${idRaw}` : null;
        addKey(acc, idKey, item);

        idxCandidates.forEach((idxVal) => {
          const idxKey = `idx:${idxVal}`;
          addKey(acc, idxKey, item);
        });

        return acc;
      }, {});
    },
    attachDiffsToTricks(tricks, diffByKey) {
      const resolveTrickKeys = (trick, idx, allowIdx) => {
        const idVal = trick?.trick_entry_id
          ?? trick?.validated_trick_id
          ?? trick?.validated_trick_entry_id
          ?? trick?.trick_id
          ?? trick?.id
          ?? null;

        const idxVal = allowIdx && Number.isInteger(trick?.index)
          ? trick.index
          : (allowIdx && Number.isInteger(trick?.trick_index) ? trick.trick_index : (allowIdx && Number.isInteger(idx) ? idx : null));

        const idKey = idVal !== null ? `id:${idVal}` : null;
        const idxKey = allowIdx && Number.isInteger(idxVal) ? `idx:${idxVal}` : null;

        return { idKey, idxKey };
      };

      const attachDiff = (trick, idx, allowIdx = true) => {
        if (!trick || typeof trick !== 'object') return trick;

        const { idKey, idxKey } = resolveTrickKeys(trick, idx, allowIdx);
        const diff = (idKey && diffByKey[idKey]) || (idxKey && diffByKey[idxKey]) || null;
        const withDiff = diff ? { ...trick, __diff: diff } : { ...trick };

        if (Array.isArray(withDiff.body) && withDiff.header) {
          withDiff.body = withDiff.body.map((subTrick, subIdx) => {
            const fallbackIndex = subTrick?.index ?? subTrick?.trick_index ?? subIdx;
            // For sub-tricks inside combos, avoid matching by idx to prevent cross-talk with top-level diffs
            return attachDiff(subTrick, fallbackIndex, false);
          });
        }

        return withDiff;
      };

      return (tricks || []).map((trick, idx) => attachDiff(trick, idx, true));
    },
    handleOpenEditorDiff(payload) {
      const editorId = this.resolveEditorId(payload);
      if (!editorId) return;

      this.editorDiffEvent = {
        id: editorId,
        editor: payload?.diff?.editor || payload?.editor || null,
        ts: Date.now(),
      };
    },
    resolveEditorId(payload) {
      const editor = payload?.diff?.editor || payload?.editor || {};
      return editor.judge_id
        || editor.id
        || editor.user_id
        || payload?.diff?.editor_id
        || payload?.editorId
        || payload?.id
        || null;
    },
    async viewJudgeProfile(id) {
      await router.push(`/profile/${id}`);
    },
    calculateScoringDuration(started, completed) {
      if (!started || !completed) return null;
      const startMs = Date.parse(started);
      const endMs = Date.parse(completed);
      if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return null;
      const totalSeconds = Math.max(0, Math.round((endMs - startMs) / 1000));
      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    async cancelUpdateRound(round) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token, 'rounds', round, 21, 'judge_panel');
      if (response.data?.success) {
        this.validatedTricks = [];
        this.selectedListTricks = [];
        this.comboSelected = [];
        this.comboCount = 1;
        this.totalScorePrint = {
          'style': '0%',
          'score': 0,
        };
        localStorage.removeItem('validatedTricks');
        localStorage.removeItem('selectedTricks');
        localStorage.removeItem('comboCount');
        localStorage.removeItem('videoUrl');
        this.videoUrl = null;
        this.clearRoundIdToUpdate();
        this.clearRoundIdToView();
        this.clearRoundAthleteId();
        this.hideLoading();
        if (this.competitionIdToView) {
          this.clearCompetitionRoundIdToUpdate();
          this.clearCompetitionRoundIdToEdit();
          this.round_update = false;
          this.round_view = false;
          await router.push('/competitionView');
        } else {
          this.round_update = false;
          this.round_view = false;
          await router.push('/home');
        }
      } else {
        console.log('⚠️ Falló');
        this.hideLoading();
      }

    },
    async storageScoreList() {
      const isConfirmed = await this.confirmWithModal(this.$t('training.modal.save_new_round_confirm'));
      if (isConfirmed) {
        try {
          this.showLoading();
          const response = await this.$axios.post("/store", {
            modeProgram: this.modeProgram,
            competitionDetails: this.competitionDetails && Object.keys(this.competitionDetails).length ? this.competitionDetails.id : null,
            athleteId: this.athleteId,
            training_type: this.trainingType,
            assigned_judge_id: this.assignedJudgeId,
            validatedTricks: this.validatedTricks,
            totalScorePrint: this.totalScorePrint,
            countUniqueTrick: this.countUniqueTrick.total,
            round_name: this.roundName,
            totalScore: this.totalScore,
            videoUrl: this.videoUrl,
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
          if (response.status === 200){
            this.disableTrainingJudgeScoringCancel();
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.athleteId = null;
            this.athleteData = null;
            this.competitionDetails = [];
            this.trainingType = 'athlete';
            this.assignedJudgeId = null;
            this.comboCount = 1;
            this.totalScorePrint = {
              'style' : '0%',
              'score' : 0,
            };
            this.validatedTricksDiffs = [];
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');
            localStorage.removeItem('athleteId');
            // this.$emit('clear-validated-tricks');
            this.hideLoading();
            if (this.competitionIdToView){
              this.clearRoundIdToUpdate();
              this.clearRoundIdToView();
              this.clearRoundAthleteId();
              await router.push('/competitionView');
            }else{
              this.clearTrainingRoundsIdToView();
              this.clearTrainingRoundsIdToCreate();
              this.clearTrainingRoundsIdToEdit();
              await router.push('/training');
            }

          }

        } catch (error) {
          console.error('Error al guardar trucos validados:', error);
        }

      }
    },
    async updateScoreRound() {
      const isConfirmed = await this.confirmWithModal('Are you sure you want to update the round?');
      if (isConfirmed) {
        try {
          this.showLoading();
          let round_id = this.trainingRoundsIdToEdit;

          const response = await this.$axios.post(`/update_round`, {
            modeProgram: this.modeProgram,
            validatedTricks: this.validatedTricks,
            totalScorePrint: this.totalScorePrint,
            countUniqueTrick: this.countUniqueTrick.total,
            totalScore: this.totalScore,
            roundId: round_id,
            round_name: this.roundName,
            videoUrl: this.videoUrl,
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
          if (response.status === 200){
            this.disableTrainingJudgeScoringCancel();
            this.validatedTricks = [];
            this.selectedListTricks = [];
            this.comboSelected = [];
            this.comboCount = 1;
            this.totalScorePrint = {
              'style' : '0%',
              'score' : 0,
            };
            localStorage.removeItem('validatedTricks');
            localStorage.removeItem('selectedTricks');
            localStorage.removeItem('comboCount');
            localStorage.removeItem('videoUrl');

            // this.$emit('clear-validated-tricks');
            this.hideLoading();
            this.round_update = false;
            if (this.competitionIdToView){
              this.clearCompetitionRoundIdToUpdate();
              this.clearCompetitionRoundIdToEdit();
              await router.push('/competitionView');
            }else{
              this.clearTrainingRoundsIdToView();
              this.clearTrainingRoundsIdToCreate();
              this.clearTrainingRoundsIdToEdit();
              await router.push('/training');
            }
          }
        } catch (error) {
          console.error('Error al guardar trucos validados:', error);
        }
      }
    },

    deleteVideoUrlComponent(){
      if (this.trainingType === 'judge' && this.isTraining && !this.isSupervisor(this.user)) {
        return;
      }
      this.videoUrl = null;
      localStorage.removeItem('videoUrl');
    },
    isJudgeTrainingRound(round) {
      return Boolean(round && round.training_type === 'judge');
    },
    async startTrainingJudgeScoringIfNeeded(round) {
      if (!this.isJudgeTrainingRound(round)) {
        this.disableTrainingJudgeScoringCancel();
        return;
      }

      const isAlreadyCompleted = Boolean(round.already_completed || round.completed_scoring_at);
      if (isAlreadyCompleted) {
        this.disableTrainingJudgeScoringCancel();
        return;
      }

      if (this.trainingJudgeScoringRoundId === round.id && this.shouldCancelTrainingJudgeScoring) {
        return;
      }

      try {
        const response = await this.$axios.post(`/training/rounds/${round.id}/start`, {}, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        const startedRound = response?.data?.round || null;
        this.trainingJudgeScoringRoundId = round.id;
        this.shouldCancelTrainingJudgeScoring = true;

        if (startedRound) {
          this.scoringDurationText = this.calculateScoringDuration(
            startedRound.started_scoring_at,
            startedRound.completed_scoring_at
          );
        }
      } catch (error) {
        console.error('❌ Error al iniciar scoring de training juez:', error);
      }
    },
    async cancelTrainingJudgeScoringIfNeeded() {
      if (!this.shouldCancelTrainingJudgeScoring || !this.trainingJudgeScoringRoundId) {
        return;
      }

      try {
        await this.$axios.post(`/training/rounds/${this.trainingJudgeScoringRoundId}/cancel`, {}, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
      } catch (error) {
        console.error('❌ Error al cancelar scoring de training juez:', error);
      } finally {
        this.disableTrainingJudgeScoringCancel();
      }
    },
    disableTrainingJudgeScoringCancel() {
      this.shouldCancelTrainingJudgeScoring = false;
      this.trainingJudgeScoringRoundId = null;
    },
    async fetchCompetitionDetails(competitionId) {
      this.showLoading();
      try {
        const response = await this.$axios.get(`/competition/${competitionId}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.competitionDetails = response.data.competition;
        await this.setCompetition(this.competitionDetails);
        await this.setCompetitionIdToView(competitionId);
        await this.upsertCompetition(this.competitionDetails);
        this.modeProgram = this.competitionDetails.rule_id;
        await this.syncTricklistForContext({ competitionId });
        // this.isExpanded[7] = true;
        this.hideLoading();
      } catch (error) {
        console.error('Error al obtener las rondas:', error);
      }
    },
    getTricklistHintVersionId(round = null) {
      return round?.effective_tricklist_version_id
        || round?.tricklist_version?.id
        || this.competitionDetails?.tricklist_version_id
        || this.competitionDetails?.tricklist_version?.id
        || null;
    },
    async syncTricklistForContext({ round = null, competitionId = null, force = false } = {}) {
      const activeRound = round || this.currentRound;
      const hintedVersionId = this.getTricklistHintVersionId(activeRound);
      const requestParams = activeRound?.id
        ? { round_id: activeRound.id }
        : (competitionId || this.competitionDetails?.id)
          ? { competition_id: competitionId || this.competitionDetails.id }
          : null;

      if (!force && hintedVersionId && hintedVersionId === this.activeTricklistVersionId && Array.isArray(this.tricks) && this.tricks.length) {
        return;
      }

      if (!force && hintedVersionId) {
        const cached = readCachedTricklist(secureStorage, hintedVersionId);
        if (cached.length) {
          this.tricks = cached;
          this.activeTricklistVersionId = hintedVersionId;
          return;
        }
      }

      if (!requestParams) {
        return;
      }

      try {
        const response = await this.$axios.get('/tricks', {
          params: requestParams,
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (response.status !== 200) {
          return;
        }

        const normalizedTricks = normalizeTricklistEntries(response.data?.tricks || []);
        const resolvedVersionId = response.data?.tricklist_version_id ?? hintedVersionId ?? null;

        this.tricks = normalizedTricks;
        this.activeTricklistVersionId = resolvedVersionId;
        writeCachedTricklist(secureStorage, resolvedVersionId, normalizedTricks);
      } catch (error) {
        console.error('Error al descargar Tricklist:', error);
      }
    },
    formatScore(score) {
      const num = parseFloat(score);
      if (isNaN(num)) return score;
      if (num <= 0) return '-';
      return num.toFixed(2);
    },
    editInfoRound() {
      this.openModalState({
        message: "You are about to edit a training round",
        showCancel: true,
        showRuleSelector: false,
        showNameInput: true,
      });
    },
    async handleConfirmed({ selectedRule, customName }) {
      if (this.pendingConfirmResolver) {
        const resolve = this.pendingConfirmResolver;
        this.resetConfirmationModalState();
        resolve(true);
        return;
      }

      this.roundName = customName;
      this.modeProgram = selectedRule;
      // si estás editando un round existente
      if (this.trainingRoundsIdToEdit) {

        const round = this.trainingRounds.find(r => r.id === this.trainingRoundsIdToEdit);
        if (round) round.round_name = customName;
      }
    },
    async confirmModal() {
      console.log("🔥 Modal Confirmado");
    },
    cancelModal() {
      if (this.pendingConfirmResolver) {
        const resolve = this.pendingConfirmResolver;
        this.resetConfirmationModalState();
        resolve(false);
        return;
      }

      this.resetConfirmationModalState();
    },
    resetConfirmationModalState() {
      this.pendingConfirmResolver = null;
      this.modalMessage = "";
      this.showCancel = false;
      this.modalShowRuleSelector = false;
      this.modalShowNameInput = false;
    },
    openModalState({ message, showCancel = true, showRuleSelector = false, showNameInput = false }) {
      this.modalMessage = message;
      this.showCancel = showCancel;
      this.modalShowRuleSelector = showRuleSelector;
      this.modalShowNameInput = showNameInput;
      this.$refs.confirmationModal.openModal();
    },
    confirmWithModal(message) {
      return new Promise((resolve) => {
        this.pendingConfirmResolver = resolve;
        this.openModalState({
          message,
          showCancel: true,
          showRuleSelector: false,
          showNameInput: false,
        });
      });
    },
    resetRoundContext() {
      this.athleteData = null;
      this.judgeData = null;
      this.editors = [];
      this.scoringDurationText = null;
      this.trainingJudgeAlreadyCompleted = false;
      this.validatedRound = null;
      this.roundFeedbackComment = '';
      this.videoUrl = null;
      this.hasServerTotalScore = false;
      this.validatedTricksDiffs = [];
      this.roundStatisticsVisible = false;
      this.roundStatisticsLoading = false;
      this.roundStatisticsError = '';
      this.roundStatisticsPayload = null;
      this.roundStatisticsRoundId = null;
    },
    /*Video_BOx*/
    adjustContentHeight() {
      if (!this.$refs?.scrollableContent || !this.$refs?.fixedVideoBox) {
        return;
      }

      if (this.isVideoSplitDesktop) {
        this.$refs.scrollableContent.style.marginTop = '0';
        this.$refs.scrollableContent.style.height = '';
        return;
      }

      if (this.isVideoFloating) {
        this.$refs.scrollableContent.style.marginTop = '0';
        this.$refs.scrollableContent.style.height = 'auto';
        return;
      }

      const isMobileOrTablet = window.innerWidth <= 768;
      const isFixedLayout = window.getComputedStyle(this.$refs.fixedVideoBox).position === 'fixed';

      if (isMobileOrTablet || !isFixedLayout) {
        this.$refs.scrollableContent.style.marginTop = '0';
        this.$refs.scrollableContent.style.height = 'auto';
        return;
      }

      const fixedVideoBoxHeight = this.$refs.fixedVideoBox.clientHeight;
      const navbarHeight = 60; // Altura de la navbar
      this.$refs.scrollableContent.style.marginTop = `${fixedVideoBoxHeight}px`;
      const scrollableContentHeight = window.innerHeight - (fixedVideoBoxHeight + navbarHeight);
      this.$refs.scrollableContent.style.height = `${scrollableContentHeight}px`;
    },

    saveVideoLink() {
      this.videoUrl = this.videoLink;
      secureStorage.setItem('videoUrl', JSON.stringify(this.videoUrl));
    },
    toggleVideoFloating() {
      if (!this.isDesktopViewport) {
        return;
      }

      if (!this.isVideoFloating && this.isVideoSplitDesktop) {
        this.isVideoSplit = false;
      }

      this.isVideoFloating = !this.isVideoFloating;

      this.$nextTick(() => {
        if (this.isVideoFloating) {
          this.floatingVideoSize.width = 0;
          this.ensureFloatingVideoSize();
          this.ensureFloatingVideoPosition();
        } else {
          this.stopVideoDrag();
          this.stopVideoResize();
        }

        this.adjustContentHeight();
      });
    },
    toggleVideoSplit() {
      if (!this.isDesktopViewport) {
        return;
      }

      if (!this.isVideoSplit) {
        this.isVideoFloating = false;
        this.stopVideoDrag();
        this.stopVideoResize();
      }

      this.isVideoSplit = !this.isVideoSplit;

      this.$nextTick(() => {
        this.adjustContentHeight();
      });
    },
    ensureFloatingVideoSize() {
      const videoCard = this.$refs?.videoCard;
      const videoBox = this.$refs?.fixedVideoBox;
      if (!videoCard && !videoBox) {
        return;
      }

      if (!this.floatingVideoSize.width) {
        const baseWidth = videoCard?.offsetWidth || videoBox?.offsetWidth || 0;
        this.floatingVideoSize.width = Math.max(baseWidth, 360);
      }

      this.floatingVideoSize.width = this.clampFloatingVideoWidth(this.floatingVideoSize.width);
    },
    ensureFloatingVideoPosition() {
      const videoBox = this.$refs?.fixedVideoBox;

      if (!videoBox) {
        return;
      }

      const bounds = this.getFloatingViewportBounds(videoBox);
      const nextX = this.floatingVideoPosition.x > 0 ? this.floatingVideoPosition.x : bounds.maxX;
      const nextY = this.floatingVideoPosition.y > 0 ? this.floatingVideoPosition.y : bounds.minY;

      this.floatingVideoPosition = this.clampFloatingVideoPosition(nextX, nextY);
    },
    clampFloatingVideoPosition(x, y) {
      const videoBox = this.$refs?.fixedVideoBox;

      if (!videoBox) {
        return { x, y };
      }

      const bounds = this.getFloatingViewportBounds(videoBox);

      return {
        x: Math.min(Math.max(x, bounds.minX), bounds.maxX),
        y: Math.min(Math.max(y, bounds.minY), bounds.maxY),
      };
    },
    clampFloatingVideoWidth(width) {
      const padding = 24;
      const minWidth = 320;

      const maxWidth = Math.max(window.innerWidth - padding, minWidth);
      return Math.min(Math.max(width, minWidth), maxWidth);
    },
    getFloatingViewportBounds(videoBox = this.$refs?.fixedVideoBox) {
      const padding = 12;
      const navbar = document.querySelector('.navbar');
      const navbarRect = navbar?.getBoundingClientRect?.();
      const navbarBottom = navbarRect && navbarRect.bottom > 0 ? navbarRect.bottom : 0;
      const minY = Math.max(padding, Math.round(navbarBottom + padding));
      const videoWidth = videoBox?.offsetWidth || this.floatingVideoSize.width || 0;
      const videoHeight = videoBox?.offsetHeight || 0;

      return {
        minX: padding,
        minY,
        maxX: Math.max(window.innerWidth - videoWidth - padding, padding),
        maxY: Math.max(window.innerHeight - videoHeight - padding, minY),
      };
    },
    startVideoDrag(event) {
      if (!this.isVideoFloating || this.isVideoSplitDesktop || event.button !== 0) {
        return;
      }

      if (event.target.closest('button')) {
        return;
      }

      const videoBox = this.$refs?.fixedVideoBox;
      if (!videoBox) {
        return;
      }

      const rect = videoBox.getBoundingClientRect();
      this.videoDragState.active = true;
      this.videoDragState.pointerOffsetX = event.clientX - rect.left;
      this.videoDragState.pointerOffsetY = event.clientY - rect.top;

      window.addEventListener('mousemove', this.handleVideoDrag);
      window.addEventListener('mouseup', this.stopVideoDrag);
      document.body.classList.add('video-dragging-active');
    },
    handleVideoDrag(event) {
      if (!this.videoDragState.active || !this.isVideoFloating || this.isVideoSplitDesktop) {
        return;
      }

      const nextX = event.clientX - this.videoDragState.pointerOffsetX;
      const nextY = event.clientY - this.videoDragState.pointerOffsetY;

      this.floatingVideoPosition = this.clampFloatingVideoPosition(nextX, nextY);
    },
    stopVideoDrag() {
      this.videoDragState.active = false;
      window.removeEventListener('mousemove', this.handleVideoDrag);
      window.removeEventListener('mouseup', this.stopVideoDrag);
      document.body.classList.remove('video-dragging-active');
    },
    startVideoResize(event) {
      if (!this.isVideoFloating || this.isVideoSplitDesktop || event.button !== 0) {
        return;
      }

      const videoBox = this.$refs?.fixedVideoBox;
      if (!videoBox) {
        return;
      }

      this.videoResizeState.active = true;
      this.videoResizeState.startX = event.clientX;
      this.videoResizeState.startWidth = videoBox.offsetWidth;

      window.addEventListener('mousemove', this.handleVideoResize);
      window.addEventListener('mouseup', this.stopVideoResize);
      document.body.classList.add('video-dragging-active');
    },
    handleVideoResize(event) {
      if (!this.videoResizeState.active || !this.isVideoFloating || this.isVideoSplitDesktop) {
        return;
      }

      const deltaX = event.clientX - this.videoResizeState.startX;
      this.floatingVideoSize.width = this.clampFloatingVideoWidth(this.videoResizeState.startWidth + deltaX);

      this.$nextTick(() => {
        this.floatingVideoPosition = this.clampFloatingVideoPosition(this.floatingVideoPosition.x, this.floatingVideoPosition.y);
      });
    },
    stopVideoResize() {
      this.videoResizeState.active = false;
      window.removeEventListener('mousemove', this.handleVideoResize);
      window.removeEventListener('mouseup', this.stopVideoResize);
      document.body.classList.remove('video-dragging-active');
    },
    updateViewportFlags() {
      this.isDesktopViewport = window.innerWidth >= 992;

      if (!this.isDesktopViewport && this.isVideoSplit) {
        this.isVideoSplit = false;
      }

      if (!this.isDesktopViewport && this.isVideoFloating) {
        this.isVideoFloating = false;
        this.stopVideoDrag();
        this.stopVideoResize();
      }
    },
    handleFloatingViewportChange() {
      this.updateViewportFlags();

      this.$nextTick(() => {
        if (this.isVideoFloating && !this.isVideoSplitDesktop) {
          this.ensureFloatingVideoSize();
          this.ensureFloatingVideoPosition();
        }

        this.adjustContentHeight();
      });
    },
    /*Utils for Counters*/
    async getTrickListUpdated(){
      await this.syncTricklistForContext({ force: true });
    },
    getKeyForTrick(trick) {
      if (trick.id !== undefined) {
        return trick.id + (trick.variation ? ` - ${trick.variation}` : '') + (trick.grab ? ` - ${trick.grab}` : '');
      } else {
        return undefined;
      }
    },
    getCountCombos(){
      let counterId = JSON.parse(localStorage.getItem('comboCount')) || 1;
      const countTricks = (singleTrick) => {
        singleTrick.forEach(currentTrick => {
          if (Array.isArray(currentTrick.body) && currentTrick.body.length > 0) {
            counterId = currentTrick.header.combo_id + 1;
          }
        });
      };
      countTricks(this.validatedTricks);
      this.comboCount = counterId;
      localStorage.setItem('comboCount', JSON.parse(this.comboCount));
    },
    scrollToElement(element){
      const elementToScroll = document.getElementById(element);
      if (elementToScroll) {
        const scrollOptions = {
          behavior: 'smooth',
        };
        const elementPosition = elementToScroll.getBoundingClientRect();
        window.scrollTo({
          top: window.scrollY + elementPosition.top,
          ...scrollOptions,
        });
      }

    },
    showLoading() {
      this.$nextTick(() => {
        if (this.$root.$refs.globalLoading) {
          this.$root.$refs.globalLoading.showLoading();
        }
      });
    },
    hideLoading() {
      this.$nextTick(() => {
        if (this.$root.$refs.globalLoading) {
          this.$root.$refs.globalLoading.hideLoading();
        }
      });
    },
    toggleCollapse() {
      // Cambiar el estado de expansión al hacer clic en el botón
      this.isExpanded = !this.isExpanded;
      // if (!this.isExpanded) {
      //   this.$nextTick(() => {
      //     this.adjustContentHeight();
      //   });
      // }
    },

    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight; // Activa el reflujo
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = "opacity 0.2s";
      el.style.opacity = 0;
      done();
    },
    /*Scoring*/
    calculateTotalWithRules() {
      if (this.isView && this.hasServerTotalScore) {
        // Aunque usamos el total del servidor, recalculamos combos y estilo para mostrarlos correctamente
        const preservedTotal = this.totalScorePrint.score;
        this.calculateTotalComboNow();
        this.calculateVarietyPlus();
        this.calculateStyleRound();
        this.totalScorePrint.score = preservedTotal;
        return this.totalScorePrint;
      }

      const rulesApplyToScore_1 = () => {
        return this.calculateWithOutRules();
      };
      const rulesApplyToScore_2 = () => {
        this.getCountCombos();
        this.calculateRepetitionsTricks();
        this.calculateDubsTricks();
        this.calculateTotalCombo();
        this.calculateTotalComboNow();
        this.calculateVarietyPlus();
        return this.calculateStyleRound();
      };
      const rulesApplyToScore_3 = () => {
        this.getCountCombos();
        this.calculateRepetitionsTricks();
        this.calculateDubsTricks();
        this.calculateTotalComboPlus();
        this.calculateTotalComboNow();
        this.calculateVarietyPlus();
        return this.calculateStyleRound();
      };
      const rulesApplyToScore_4 = () => {
        this.getCountCombos();
        this.calculateRepetitionsTricks();
        this.calculateDubsTricks();
        this.calculateTotalCombo_10();
        this.calculateTotalComboLevel();
        this.calculateTotalComboAirLevel()
        this.calculateTotalComboNow();
        this.calculateVarietyPlus();
        return this.calculateStyleRound();
      };

      switch (true) {
        case this.modeProgram === 1:
          return rulesApplyToScore_1();
        case this.modeProgram === 2:
          return rulesApplyToScore_2();
        case this.modeProgram === 3:
          return rulesApplyToScore_3();
        case this.modeProgram === 4:
          return rulesApplyToScore_4();
        default:
          console.error('Modo no reconocido:', this.modeProgram);
          return this.totalScore;
      }
    },
    /*NOT Rules*/
    calculateWithOutRules(){
      this.totalScorePrint.style = '0%';
      this.totalScorePrint.score = this.totalScore;
    },
    /*Basics*/
    calculateRepetitionsTricks() {
      const trickCounts = new Map();
      const countTricks = (singleTrick) => {
        singleTrick.forEach(currentTrick => {
          const key = this.getKeyForTrick(currentTrick);
          if (key !== undefined) {
            if (!trickCounts.has(key)) {
              trickCounts.set(key, { count: 1, trick: currentTrick });
              this.resetScoreValue(currentTrick);
            } else {
              trickCounts.get(key).count += 1;
              this.handleRepetitionCount(currentTrick,trickCounts.get(key).count);
            }
          }
          if (Array.isArray(currentTrick.body)) {
            countTricks(currentTrick.body);
          }
        });
      };
      return countTricks(this.validatedTricks);
    },
    handleRepetitionCount(currentTrick,count){
      if (count === 2) {
        currentTrick.score = currentTrick.value * SCORING_LESS_25;
      } else if (count === 3) {
        currentTrick.score = currentTrick.value * SCORING_LESS_50;
      } else {
        currentTrick.score = currentTrick.value * SCORING_LESS_75;
      }
    },
    resetScoreValue(currentTrick){
      currentTrick.score = currentTrick.value;
    },
    calculateDubsTricks() {
      const dubTricks = (singleTrick) => {
        singleTrick.forEach(currentTrick => {
          if (currentTrick.dub === 1) {
            currentTrick.score *= SCORING_DUB_20;
          } else if (currentTrick.dub === 2) {
            currentTrick.score *= SCORING_DUB_50;
          } else if (currentTrick.dub > 2) {
            currentTrick.score *= SCORING_DUB_80;
          }
          if (Array.isArray(currentTrick.body)) {
            dubTricks(currentTrick.body);
          }
        });
      };
      return dubTricks(this.validatedTricks);
    },
    /*TJS 3.2*/
    calculateTotalCombo() {
      const calculateScore = (tricks) => {
        tricks.forEach((trick) => {
          if (Array.isArray(trick.body)) {
            let longSelected = trick.body.length || 0;
            if (longSelected){
              switch (true) {
                case longSelected === 1:
                  break;
                case longSelected >= 2 && longSelected <= 5:
                  trick.body.forEach((trick) => {
                    trick.score *=SCORING_COMBO_PLUS;
                  });
                  break;
                case longSelected >= 6:
                  trick.body.forEach((trick) => {
                    trick.score *= SCORING_COMBO_PLUS_6;
                  });
                  break;
                default:
                  break;
              }
            }
          }
        });
        return 0;
      };
      return calculateScore(this.validatedTricks);
    },
    calculateTotalComboPlus() {
      const calculateScore = (tricks) => {
        tricks.forEach((trick) => {
          if (Array.isArray(trick.body)) {
            let longSelected = trick.body.length || 0;
            if (longSelected){
              let lastCombo = trick.body[longSelected - 1];
              let isTypeOne = lastCombo.type === 1;
              if (isTypeOne){
                switch (true) {
                  case longSelected === 1:
                    break;
                  case longSelected >= 2 && longSelected <= 5 && isTypeOne:
                    trick.body.forEach((trick) => {
                      trick.score *= SCORING_COMBO_PLUS_FEET;
                    });
                    break;
                  case longSelected >= 6 && isTypeOne:
                    trick.body.forEach((trick) => {
                      trick.score *= SCORING_COMBO_PLUS_6_FEET;
                    });
                    break;
                  default:
                    break;
                }
              }else{
                switch (true) {
                  case longSelected === 1:
                    break;
                  case longSelected >= 2 && longSelected <= 5:
                    trick.body.forEach((trick) => {
                      trick.score *=SCORING_COMBO_PLUS;
                    });
                    break;
                  case longSelected >= 6:
                    trick.body.forEach((trick) => {
                      trick.score *= SCORING_COMBO_PLUS_6;
                    });
                    break;
                  default:
                    break;
                }
              }

            }
          }
        });
        return 0;
      };
      return calculateScore(this.validatedTricks);
    },
    calculateTotalComboNow() {
      const calculateScore = (tricks) => {
        tricks.forEach((trick) => {
          if (Array.isArray(trick.body)) {
            trick.body.reduce((subTotal, subTrick) => {
              trick.header.total_score = subTotal + (subTrick.score || 0);
              return subTotal + (subTrick.score || 0);
            }, 0);
          }
        });
        return 0;
      };
      return calculateScore(this.validatedTricks);

    },
    calculateVarietyPlus(){
      const trickCounts = new Map()
      const totalReturn = {
        'details' :trickCounts,
        'total' : 0
      };
      const countTricks = (tricks) => {
        tricks.forEach(trick => {
          const key = this.getKeyForTrick(trick);
          if (key !== undefined) {
            trickCounts.set(key, (trickCounts.get(key) || 0) + 1);
          }
          if (Array.isArray(trick.body)) {
            countTricks(trick.body);
          }
        });
      };
      countTricks(this.validatedTricks);
      totalReturn.total = trickCounts.size;
      return totalReturn.total;
    },
    calculateStyleRound() {
      let grabCount = 0;
      const countTricks = (tricks) => {
        tricks.forEach((currentTrick) => {
          if (currentTrick.grab) {
            grabCount++;
          }
          if (Array.isArray(currentTrick.body)) {
            countTricks(currentTrick.body);
          }
        });
      };

      countTricks(this.validatedTricks);

      switch (true) {
        case grabCount === 1:
          this.totalScorePrint.style = '5%';
          this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_1) + this.calculateVarietyPlus();
          break;
        case grabCount >=2 && grabCount <= 3:
          this.totalScorePrint.style = '10%';
          this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_2) + this.calculateVarietyPlus();
          break;
        case grabCount >=4 && grabCount <= 6:
          this.totalScorePrint.style = '15%';
          this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_4) + this.calculateVarietyPlus();
          break;
        case grabCount >= 7:
          this.totalScorePrint.style = '20%';
          this.totalScorePrint.score = (this.totalScore * SCORING_STYLE_PLUS_7) + this.calculateVarietyPlus();
          break;
        default:
          this.totalScorePrint.style = '0%';
          this.totalScorePrint.score = this.totalScore + this.calculateVarietyPlus();
          break;
      }
      return this.totalScorePrint;
    },
    /*TJS 4.0*/
    calculateTotalCombo_10() {
      const calculateScore = (tricks) => {
        tricks.forEach((trick) => {
          if (Array.isArray(trick.body)) {
            let longSelected = trick.body.length || 0;
            if (longSelected > 0) {
              trick.body.forEach((trick, index) => {
                const multiplier = 1 + 0.02 * (index + 1);
                trick.score *= multiplier;
              });
            }
          }
        });
        return 0;
      };
      return calculateScore(this.validatedTricks);
    },
    calculateTotalComboLevel() {
      const comboSame = [];
      const comboBalanced = [];
      const comboMixto = [];

      this.validatedTricks.forEach((trick) => {
        if (trick && trick.header && Array.isArray(trick.body) && trick.body.length > 0) {
          const comboId = trick.header.combo_id;

          const sameLevel = trick.body.every(item => item.level === trick.body[0].level);

          if (sameLevel) {
            comboSame.push(comboId);
          } else {
            const counts = trick.body.reduce((acc, item) => {
              acc[item.level] = (acc[item.level] || 0) + 1;
              return acc;
            }, {});

            const totalTricks = trick.body.length;
            const expectedCount = totalTricks / 4;

            const isBalanced = Object.values(counts).every(count => count === expectedCount);

            if (isBalanced) {
              comboBalanced.push(comboId);
            } else {
              comboMixto.push(comboId);
            }
          }
        }
      });

      if (comboSame.length > 0) {
        comboSame.forEach((comboId) => {
          const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
          if (combo) {
            combo.body.forEach((trick) => {
              switch (trick.level) {
                case 1:
                  trick.score *= 1.05;
                  break;
                case 2:
                  trick.score *= 1.10;
                  break;
                case 3:
                  trick.score *= 1.15;
                  break;
                case 4:
                  trick.score *= 1.20;
                  break;
                default:
                  break;
              }
            });
          }
        });
      }
      if (comboBalanced.length > 0) {
        comboBalanced.forEach((comboId) => {
          const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
          if (combo) {
            combo.body.forEach((trick) => {
              trick.score *= 1.125;
            });
          }
        });
      }
      if (comboMixto.length > 0) {
        comboMixto.forEach((comboId) => {
          const combo = this.validatedTricks.find((trick) => trick.header && trick.header.combo_id === comboId);
          if (combo) {
            // Inicializar un objeto para contar trucos por nivel
            const counts = { 1: 0, 2: 0, 3: 0, 4: 0 };

            // Contar trucos por nivel
            combo.body.forEach((trick) => {
              counts[trick.level]++;
            });

            combo.body.forEach((trick) => {
              let porcentLevel = ((counts[1]/combo.body.length)*0.05)*100 + ((counts[2]/combo.body.length)*0.10)*100 + ((counts[3]/combo.body.length)*0.15)*100 + ((counts[4]/combo.body.length)*0.20)*100;
              trick.score *= (1+(porcentLevel/100));
            });
          }
        });
      }

    /*  if (comboSame.length === 0 && comboBalanced.length === 0 && comboMixto.length === 0) {
        console.log("No se encontró ningún combo balanceado ni mixto ni iguales");
      }*/

      return 0;
    },
    calculateTotalComboAirLevel() {
      const calculateScore = (tricks) => {
        tricks.forEach((trick) => {
          if (Array.isArray(trick.body)) {
            let longSelected = trick.body.length || 0;
            if (longSelected){
              let lastCombo = trick.body[longSelected - 1];
              let isTypeOne = lastCombo.type === 1;
              if (isTypeOne){
                switch (lastCombo.level) {
                  case 1:
                    trick.body.forEach((trick) => {
                      trick.score *= 1.10;
                    });
                    break;
                  case 2:
                    trick.body.forEach((trick) => {
                      trick.score *= 1.15;
                    });
                    break;
                  case 3:
                    trick.body.forEach((trick) => {
                      trick.score *= 1.20;
                    });
                    break;
                  case 4:
                    trick.body.forEach((trick) => {
                      trick.score *= 1.30;
                    });
                    break;
                  default:
                    break;
                }
              }

            }
          }
        });
        return 0;
      };
      return calculateScore(this.validatedTricks);
    },



    /*Tutorial*/

  }
};
</script>

<style scoped>

.box_component {
  width: 100%;
  max-width: 100%;
  margin: 15px auto;
}

.judging-program-view {
  position: relative;
}

.program-layout {
  display: block;
}

.fixed-video-box--floating {
  position: fixed;
  z-index: 1080;
  width: min(550px, calc(100% - 24px));
}

.video-card--floating {
  width: 100%;
  max-width: none;
  margin: 0;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.24);
  position: relative;
}

.video-card-header--draggable {
  cursor: move;
  user-select: none;
}

.video-resize-handle {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.82);
  color: #fff;
  cursor: nwse-resize;
  z-index: 2;
}

.video-resize-handle:hover {
  background: rgba(17, 24, 39, 0.95);
}

.video-resize-handle i {
  transform: rotate(90deg);
}

.scrollable-content {
  overflow-y: auto;
}

.video-split-toggle {
  display: none;
  text-decoration: none;
}

.video-split-toggle:hover,
.video-split-toggle:focus,
.video-split-toggle:active {
  text-decoration: none;
}

@media (max-width: 768px) {
  .fixed-video-box--floating {
    width: calc(100% - 24px);
  }
}

@media (min-width: 769px) {
  .box_component {
    width: 100%;
    max-width: 100%;
  }

  .fixed-video-box--floating {
    width: min(650px, calc(100% - 24px));
  }
}

@media (min-width: 992px) {
  .video-split-toggle {
    display: inline-flex;
  }

  .program-layout--split {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(420px, 1fr);
    gap: 24px;
    align-items: start;
  }

  .program-layout--split .scrollable-content {
    grid-column: 1;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 0;
    max-height: calc(100vh - 24px);
    overflow-y: auto;
    padding-right: 8px;
  }

  .program-layout--split .fixed-video-box {
    grid-column: 2;
    grid-row: 1;
    position: sticky;
    top: 12px;
    align-self: start;
    width: 100%;
  }

  .program-layout--split .fixed-video-box .box_component,
  .program-layout--split .scrollable-content .box_component {
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .program-layout--split .video-card--floating {
    box-shadow: none;
  }
}




/*ScoringBox*/
.bar-item {
  flex: 1 1 50%;
  padding: 10px;
  box-sizing: border-box;
}
.total-bar,.total-style-bar,.total-variety-bar,.total-score-bar {
  background-color: rgba(76, 175, 80, 0.97);
  color: #000;
  padding: 8px;
  text-align: center;
  border-radius: 4px;
  margin-top: 10px;
  transition: background-color 0.3s, color 0.3s;
}
.total-style-bar {
  background-color: rgba(168, 151, 99, 0.4);
}
.total-variety-bar {
  background-color: rgba(73, 69, 46, 0.4);
}
.total-score-bar {
  background-color: rgb(203, 169, 74);
}

.score-label {
  font-size: 0.9em;
}

.score-value {
  font-size: 1.4em;
}
.clear-btn {
  width: 100%;
  background-color: #ff4d4d;
  color: white;
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.clear-btn:hover {
  background-color: #cc0000;
}
.link-plain {
  cursor: pointer;
  text-decoration: underline;
  border: none;
  outline: none;
  color: inherit;
  background: none;
  font-size: 12px;
}
.locked-wrapper {
  position: relative;
}

.locked-wrapper .locked-body {
  position: relative;
}

.locked-wrapper.locked .locked-body {
  pointer-events: none;
  opacity: 0.35;
  filter: blur(1px);
}

.locked-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.78);
  z-index: 5;
  text-align: center;
  padding: 12px;
}

.locked-overlay__content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #111827;
}

.code-input {
  max-width: 120px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.code-input-group {
  justify-content: center;
  gap: 8px;
}

@media (max-width: 576px) {
  .bar-item {
    flex-direction: column;
    gap: 4px;
  }
  .score-label,
  .score-value {
    display: block;
    text-align: center;
  }
}
</style>